"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELL_ON_SOCIAL_MEDIA = exports.SHIPPING_LABLES = exports.AUTOMATED_SALE_TAX = exports.MULTIPLE_CURRENCIES = exports.TINY_ERP = exports.SUBSCRIPTIONS = exports.ABANDOND_CART_RECOVERY = exports.PRODUCT_CATALOG_FEATURE = exports.UNLIMITED_PRODUCTS = exports.advancedPlansBusinessCommonFeatures = exports.advancedPlansCommonFeatures = exports.FIELDS_PER_FORM = exports.LEAD_CAPTURE_FORMS = exports.CORREIOS_SHIPPING = exports.ONLINE_CREDIT_CARD_RATES_CH = exports.ONLINE_CREDIT_CARD_RATES_EU = exports.ONLINE_CREDIT_CARD_RATES_GB = exports.ONLINE_CREDIT_CARD_RATES_US = exports.CUSTOMER_ACCOUNTS = exports.RECURRING_PAYMENTS_AND_PLANS = exports.SECURE_ONLINE_PAYMENTS_EDITOR_X = exports.SECURE_ONLINE_PAYMENTS_WITH_BENEFIT = exports.SECURE_ONLINE_PAYMENTS = exports.SUPPORT_FRANCE = exports.SUPPORT_EU = exports.SUPPORT = exports.ADVANCED_REPORT_BUILDER = exports.LEGAL_TEXT_BUSINESS = exports.EVENTS_CALENDAR = exports.VISITOR_ANALYTICS = exports.LEGAL_TEXT_WEBSITE = exports.SITE_BOOSTER = exports.YANDEX_VOUCHER = exports.AD_VOUCHER_75_GB = exports.AD_VOUCHER_75 = exports.NEW_CA_AD_VOUCHER_300 = exports.NEW_US_AD_VOUCHER_300 = exports.CONTRIBUTORS = exports.STORAGE_EDITOR_X = exports.STORAGE = exports.FREE_SSL_CERTIFICATE = exports.FREE_DOMAIN_FOR_1_YEAR = exports.CONNECT_A_CUSTOM_DOMAIN = exports.REMOVE_EDITOR_X_BRANDING = exports.REMOVE_WIX_ADS = exports.BANDWIDTH = exports.STAFFY = exports.TEST_PRODUCT = exports.createFeatureValueMap = exports.createProductFeatureMap = void 0;
exports.ADVANCED_PLANS_FEATURES = exports.MULTIPLE_STAFF_MANAGEMENT = exports.STAFF_MANAGEMENT = exports.ONLINE_STORE = exports.ONLINE_SESSIONS = exports.MULTIPLE_LOCATIONS = exports.MEMBERSHIPS_PACKAGES = exports.DEDICATED_MEMBERS_APP = exports.SCHEDULING_SERVICES = exports.CUSTOMIZED_ANALYTICS = exports.AUTOMATED_REMINDERS = exports.CUSTOME_MENUS = exports.RESERVATIONS_MANAGEMENT = exports.ONLINE_ORDERS = exports.SELL_ART_WORK = exports.STREAM_SELL_MUSIC = exports.MOBILE_TICKETS_EDITOR_X = exports.MOBILE_TICKETS = exports.PASS_TICKET_FEES = exports.TICKET_SALE_COMMISION = exports.UNLIMITED_TECKETS_AND_EVENTS = exports.BOOKINGS_ANALYTICS = exports.BOOKING_ON_THE_GO_EDITOR_X = exports.BOOKING_ON_THE_GO = exports.SMS_NOTIFICATIONS_QUOTA_FEATURE = exports.SUBSCRIPTIONS_MEMBERSHIPS = exports.STAFF_SEATS_SUNRISE_STUDIO = exports.STAFF_SEATS = exports.MULTI_CALENDAR_SYNC = exports.UNLIMITED_SERVICES_CLASSES = exports.PROFESSIONAL_VIDEO_ADS = exports.SCHEDULE_SOCIAL_POSTS = exports.SHARE_SOCIAL_POSTS = exports.SCHEDULED_CHAT_HOURS = exports.ADVANCED_CHAT_FEATURES = exports.PAYMENT_FORMS = exports.MULTISTEP_FORMS = exports.CUSTOMIZABLE_FORMS = exports.AUTOMATIONS = exports.TOTAL_EMAILS = exports.EMAIL_CAMPAIGHNS = exports.LOYALTY_PROGRAM_SMILE_IO = exports.PRODUCTS_REVIEWS = exports.PRODUCT_REVIEWS_KUDOBUZZ = exports.DROPSHIPPING_MODALYST_SUNRISE = exports.DROPSHIPPING_MODALYST = exports.TRUSTED_SHOPS = exports.SELL_ON_MARKETPLACES = void 0;
var types_1 = require("../../../types");
var products_1 = require("./products");
var array_utils_1 = require("../../utils/array.utils");
var createProductFeatureMap = function (productIds) {
    var entries = productIds.map(function (id) { return [id, true]; });
    return new Map(entries);
};
exports.createProductFeatureMap = createProductFeatureMap;
var createFeatureValueMap = function (featureValue, featureIds) { return featureIds.map(function (id) { return [id, featureValue]; }); };
exports.createFeatureValueMap = createFeatureValueMap;
exports.TEST_PRODUCT = {
    translationKey: 'TEST_PRODUCT_NAME',
    tooltipTranslationKey: 'TEST_PRODUCT_TOOLTIP',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '618',
        '619',
        '659',
        '6591',
        '6592',
        '6590',
        '660',
        '6600',
        '661',
        '662',
        '663',
        '664',
        '665',
        '716',
        '729',
        '730',
        '754',
        '755',
        '756',
        '766',
        '769',
        '776',
        '777',
        '7770',
        '778',
        '7780',
        '781',
        '782',
        '783',
        '784',
        '810',
        '8100',
        '811',
        '8110',
        '812',
        '813',
        '814',
        '815',
        '816',
        '825',
        '826',
        '827',
        '828',
        '829',
        '830',
        '831',
        '906',
        '916',
        '926',
        '929',
        '1011',
    ]),
};
exports.STAFFY = {
    translationKey: 'Advanced.Features_Bookings_staffy_payroll',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_staffy_payroll',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '775',
        '776',
        '790',
        '791',
        '798',
        '799',
        '807',
        '808',
        '905',
        '906',
        '915',
        '916',
        '918',
        '925',
        '926',
        '928',
        '929',
    ]),
    value: new Map(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_staffy_4_members', [
        '775',
        '790',
        '798',
        '807',
        '905',
        '915',
        '918',
        '925',
        '928',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_staffy_unlimited_members', ['776', '791', '799', '808', '906', '916', '926', '929']), true)),
    disabledInMonthlyCycle: true,
    benefit: 'Advanced.Plans_General_Free_for_1_Year',
    includedBySpec: 'specs.premium.Adding_Staffy_To_Premium_PREM2-5774',
};
exports.BANDWIDTH = {
    translationKey: 'Advanced.Features_Core_bandwidth',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_bandwidth',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '652',
        '653',
        '654',
        '655',
        '656',
        '657',
        '658',
        '659',
        '6591',
        '6592',
        '6590',
        '660',
        '6600',
        '661',
        '662',
        '663',
        '664',
        '665',
        '673',
        '674',
        '675',
        '676',
        '677',
        '678',
        '679',
        '680',
        '6802',
        '6801',
        '6800',
        '681',
        '6810',
        '682',
        '683',
        '684',
        '685',
        '686',
        '688',
        '689',
        '690',
        '691',
        '692',
        '693',
        '694',
        '695',
        '696',
        '697',
        '698',
        '699',
        '700',
        '701',
        '717',
        '718',
        '719',
        '720',
        '721',
        '722',
        '728',
        '729',
        '730',
        '731',
        '732',
        '733',
        '734',
        '735',
        '736',
        '737',
        '738',
        '739',
        '740',
        '746',
        '747',
        '748',
        '749',
        '750',
        '751',
        '752',
        '754',
        '755',
        '756',
        '758',
        '759',
        '767',
        '768',
        '769',
        '777',
        '7770',
        '778',
        '7780',
        '779',
        '781',
        '782',
        '783',
        '784',
        '785',
        '7850',
        '786',
        '7860',
        '787',
        '788',
        '789',
        '790',
        '791',
        '800',
        '8000',
        '801',
        '8010',
        '803',
        '805',
        '806',
        '807',
        '808',
        '810',
        '8100',
        '811',
        '8110',
        '812',
        '813',
        '814',
        '815',
        '816',
        '822',
        '823',
        '824',
        '825',
        '826',
        '827',
        '828',
        '829',
        '830',
        '831',
        '832',
        '833',
        '834',
        '835',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_bandwidth_1GB', [
        '652',
        '659',
        '6591',
        '6592',
        '6590',
        '673',
        '680',
        '6802',
        '6801',
        '6800',
        '688',
        '695',
        '717',
        '718',
        '719',
        '720',
        '721',
        '722',
        '731',
        '736',
        '777',
        '7770',
        '785',
        '7850',
        '800',
        '8000',
        '810',
        '8100',
        '822',
        '825',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_bandwidth_2GB', [
        '653',
        '660',
        '6600',
        '674',
        '681',
        '6810',
        '689',
        '696',
        '732',
        '737',
        '746',
        '778',
        '7780',
        '786',
        '7860',
        '801',
        '8010',
        '811',
        '8110',
        '823',
        '826',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_bandwidth_unlimited', [
        '654',
        '655',
        '656',
        '657',
        '658',
        '661',
        '662',
        '663',
        '664',
        '665',
        '675',
        '676',
        '677',
        '678',
        '679',
        '682',
        '683',
        '684',
        '685',
        '686',
        '690',
        '691',
        '692',
        '693',
        '694',
        '697',
        '698',
        '699',
        '700',
        '701',
        '728',
        '729',
        '730',
        '733',
        '734',
        '735',
        '738',
        '739',
        '740',
        '747',
        '748',
        '749',
        '750',
        '751',
        '752',
        '754',
        '755',
        '756',
        '758',
        '759',
        '767',
        '768',
        '769',
        '779',
        '781',
        '782',
        '783',
        '784',
        '787',
        '788',
        '789',
        '790',
        '791',
        '803',
        '805',
        '806',
        '807',
        '808',
        '812',
        '813',
        '814',
        '815',
        '816',
        '824',
        '827',
        '828',
        '829',
        '830',
        '831',
        '832',
        '833',
        '834',
        '835',
    ]), true)),
};
exports.REMOVE_WIX_ADS = {
    translationKey: 'Advanced.Features_Core_Remove_Wix_Ads',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Remove_Wix_Ads',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '666',
        '741',
        '792',
        '7920',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '534',
        '514',
        '544',
        '524',
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '757',
        '809',
        '758',
        '759',
        '9999',
        '999',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '37580',
        '37579'
    ]),
};
exports.REMOVE_EDITOR_X_BRANDING = {
    translationKey: 'Editorx.Features_remove_branding',
    tooltipTranslationKey: 'Editorx.Tooltips_remove_branding',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)(['9998']),
};
exports.CONNECT_A_CUSTOM_DOMAIN = {
    translationKey: 'Advanced.Features_Core_Custom_Domain',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Custom_Domain',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '613',
        '758',
        '759',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '534',
        '514',
        '544',
        '524',
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '511',
        '541',
        '521',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '37580',
        '37579'
    ]),
};
exports.FREE_DOMAIN_FOR_1_YEAR = {
    translationKey: 'Advanced.Features_Vouchers_Free_Domain_for_1_Year',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Free_Domain_1_Year',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '758',
        '759',
        '746',
        '689',
        '696',
        '674',
        '737',
        '786',
        '7860',
        '681',
        '6810',
        '823',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '534',
        '514',
        '544',
        '524',
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '37580',
        '37579'
    ]),
    disabledInMonthlyCycle: true,
};
exports.FREE_SSL_CERTIFICATE = {
    translationKey: 'Advanced.Features_Core_SSL_certificate',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_SSL_certificate',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '534',
        '514',
        '544',
        '524',
        '511',
        '541',
        '521',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
    ]),
};
exports.STORAGE = {
    translationKey: 'Advanced.Features_Core_Storage',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Storage',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '613',
        '758',
        '759',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '534',
        '514',
        '544',
        '524',
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '511',
        '541',
        '521',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '6801',
        '6802',
        '6591',
        '6592',
        '37580',
        '37579'
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_500MB', [
        '511',
        '541',
        '521',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_3GB', [
        '501',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '674',
        '737',
        '786',
        '7860',
        '681',
        '6810',
        '823',
        '613',
        '647',
        '723',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '531',
        '512',
        '542',
        '522',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_2GB', [
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '901',
        '911',
        '930',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9403',
        '9804',
        '950',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9704',
        '2226',
        '974',
        '960',
        '9603',
        '96030',
        '37579'
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_5GB', [
        '761',
        '771',
        '917',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_10GB', [
        '502',
        '661',
        '827',
        '812',
        '747',
        '758',
        '728',
        '779',
        '752',
        '690',
        '697',
        '675',
        '738',
        '787',
        '682',
        '824',
        '614',
        '648',
        '724',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_20GB', [
        '821',
        '503',
        '615',
        '759',
        '649',
        '725',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '505',
        '617',
        '726',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_35GB', [
        '504',
        '616',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '534',
        '514',
        '544',
        '524',
        '506',
        '618',
        '727',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_50GB', [
        '507',
        '619',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '22012',
        '936',
        '37523',
        '37546',
        '946',
        '2206',
        '37519',
        '37536',
        '956',
        '37527',
        '37541',
        '971',
        '37556',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '37580'
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_50GB', [
        '902',
        '912',
        '904',
        '914',
        '924',
        '927',
        '762',
        '772',
        '764',
        '774',
        '820',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_100GB', [
        '763',
        '773',
        '903',
        '913',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '2202',
        '937',
        '37524',
        '37548',
        '947',
        '2207',
        '37520',
        '37538',
        '957',
        '959',
        '37528',
        '37543',
        '972',
        '37558',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '9920',
        '9921',
        '9922',
        '9923',
        '9924',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_unlimited', [
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999']), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.cards.feature.storage_space.business_migration', [
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9501',
        '95010',
        '9502',
        '95020',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9401',
        '9802',
        '9402',
        '9803',
        '9601',
        '96010',
        '9602',
        '96020',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_500GB', [
        '9915',
        '9916',
        '9917',
        '9918',
        '9919',
        '37537',
        '37532',
        '37542',
        '37547',
        '37552',
        '37557',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Storage_1000GB', [
        '9925',
        '9926',
        '9927',
        '9928',
        '9929',
    ]), true), (0, exports.createFeatureValueMap)('premium-plan-purchase.main_table.storage_space.connect_domain', ['6801', '6802', '6591', '6592']), true)),
};
exports.STORAGE_EDITOR_X = {
    translationKey: 'Editorx.Features_Core_Storage',
    tooltipTranslationKey: 'Editorx.Tooltips_Core_Storage',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)(['9998']),
    value: new Map(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9998']), true)),
};
exports.CONTRIBUTORS = {
    translationKey: 'Advanced.Features_Core_Contributors',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Contributors',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '531',
        '512',
        '542',
        '522',
        '502',
        '532',
        '513',
        '543',
        '523',
        '503',
        '533',
        '504',
        '534',
        '514',
        '544',
        '524',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_2', [
        '501',
        '531',
        '512',
        '542',
        '522',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_3', [
        '502',
        '532',
        '513',
        '543',
        '523',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_5', [
        '503',
        '533',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_10', [
        '504',
        '534',
        '514',
        '544',
        '524',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_15', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]), true)),
};
exports.NEW_US_AD_VOUCHER_300 = {
    translationKey: 'Advanced.Features_Vouchers_USD_Ads',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_700_USD_Ads_US',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '502',
        '614',
        '648',
        '758',
        '759',
        '724',
        '761',
        '771',
        '710',
        '703',
        '654',
        '803',
        '733',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '504',
        '505',
        '508',
        '506',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '658',
        '808',
        '735',
        '510',
        '9999',
        '9998',
        '522',
        '523',
        '524',
        '525',
        '528',
        '526',
        '529',
        '527',
        '530',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '655',
        '805',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '656',
        '806',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '657',
        '807',
        '734',
        '999',
    ]),
    disabledInMonthlyCycle: true,
    includedInGeos: [types_1.Country.USA],
    excludedBySpec: 'specs.premium.New_Google_Vouchers_PREM2-5623',
    isGoogleVoucher: true,
};
exports.NEW_CA_AD_VOUCHER_300 = {
    translationKey: 'Advanced.Features_Vouchers_USD_Ads',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_800_USD_Ads_CA',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: exports.NEW_US_AD_VOUCHER_300.includedInProducts,
    disabledInMonthlyCycle: true,
    includedInGeos: [types_1.Country.CA],
    excludedBySpec: 'specs.premium.New_Google_Vouchers_PREM2-5623',
    isGoogleVoucher: true,
};
// Google voucher
exports.AD_VOUCHER_75 = {
    translationKey: 'features.dynamic_ad_vouchers_raw.text',
    tooltipTranslationKey: 'features.dynamic_ad_vouchers_raw.tooltip',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '512',
        '667',
        '742',
        '793',
        '668',
        '743',
        '794',
        '669',
        '796',
        '670',
        '744',
        '797',
        '671',
        '745',
        '798',
        '672',
        '799',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '542',
        '513',
        '543',
        '514',
        '544',
        '515',
        '545',
        '548',
        '516',
        '546',
        '549',
        '517',
        '547',
        '550',
        '518',
        '519',
        '520',
        '532',
        '533',
        '534',
        '535',
        '538',
        '536',
        '539',
        '537',
        '540',
        '9998',
        '999',
    ]),
    disabledInMonthlyCycle: true,
    excludedBySpec: 'specs.premium.New_Google_Vouchers_PREM2-5623',
    includedInGeos: types_1.AD_VOUCHER_75_GEOS,
    isGoogleVoucher: true,
};
exports.AD_VOUCHER_75_GB = {
    translationKey: 'Advanced.Features_Vouchers_75_GBP_Ads',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_75_GBP_Ads',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '512',
        '674',
        '737',
        '786',
        '7860',
        '675',
        '738',
        '787',
        '676',
        '739',
        '788',
        '677',
        '789',
        '678',
        '740',
        '790',
        '679',
        '791',
        '513',
        '514',
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
        '999',
    ]),
    disabledInMonthlyCycle: true,
    excludedBySpec: 'specs.premium.New_Google_Vouchers_PREM2-5623',
    includedInGeos: [types_1.Country.GB],
    isGoogleVoucher: true,
};
exports.YANDEX_VOUCHER = {
    translationKey: 'Advanced.Features_Vouchers_Yandex',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Yandex_new_flow',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '543',
        '682',
        '824',
        '683',
        '832',
        '684',
        '833',
        '685',
        '834',
        '767',
        '686',
        '835',
        '768',
        '544',
        '545',
        '546',
        '547',
        '548',
        '549',
        '550',
        '9998',
    ]),
    disabledInMonthlyCycle: true,
    includedInGeos: [types_1.Country.RU],
};
exports.SITE_BOOSTER = {
    translationKey: 'Advanced.Features_Vouchers_Site_Booster_app',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Site_Booster_app',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '502',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '675',
        '738',
        '787',
        '682',
        '824',
        '614',
        '648',
        '724',
        '761',
        '771',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '514',
        '544',
        '524',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    benefit: 'Advanced.Plans_General_Free_for_1_Year',
    excludedBySpec: ['specs.premium.Uberall_App_In_PP_PREM2-13367'],
    disabledInMonthlyCycle: true,
};
exports.LEGAL_TEXT_WEBSITE = {
    translationKey: 'Advanced.Features_Core_Trusted_Shops_legal_writer_website',
    tooltipTranslationKey: 'Advanced_Tooltips_Core_Trusted_Shops_legal_writer_website',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedBySpec: 'specs.premium.TrustedShops_PREM2_2237',
    includedInProducts: (0, exports.createProductFeatureMap)([
        '502',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '675',
        '738',
        '787',
        '682',
        '824',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '514',
        '544',
        '524',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
    ]),
    disabledInMonthlyCycle: true,
};
exports.VISITOR_ANALYTICS = {
    translationKey: 'Advanced.Features_Vouchers_Visitor_Analytics_App',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Visitor_Analytics_App',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '502',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '675',
        '738',
        '787',
        '682',
        '824',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '514',
        '544',
        '524',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
    ]),
    benefit: 'Advanced.Plans_General_Free_for_1_Year',
    disabledInMonthlyCycle: true,
};
exports.EVENTS_CALENDAR = {
    translationKey: 'Advanced.Features_Vouchers_Events_Calendar_App',
    tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Events_Calendar_App',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    benefit: 'Advanced.Plans_General_Free_for_1_Year',
    disabledInMonthlyCycle: true,
};
exports.LEGAL_TEXT_BUSINESS = {
    translationKey: 'Advanced.Features_Stores_Trusted_Shops_legal_writer_business',
    tooltipTranslationKey: 'Advanced_Tooltips_Stores_Trusted_Shops_legal_writer_business',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedBySpec: 'specs.premium.TrustedShops_PREM2_2237',
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '678',
        '740',
        '790',
        '9999',
        '9998',
    ]),
    disabledInMonthlyCycle: true,
};
exports.ADVANCED_REPORT_BUILDER = {
    translationKey: 'Advanced.Features_Core_Advanced_Reports',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Advanced_Reports',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '37538',
        '37533',
        '37543',
        '37548',
        '37553',
        '37558',
    ]),
};
exports.SUPPORT = {
    translationKey: 'Advanced.Features_Core_Support',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Support',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    excludedBySpec: [
        'specs.premium.FranchPackagePicker',
        'specs.premium.JapanesePackagePicker',
    ],
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '514',
        '544',
        '524',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '511',
        '541',
        '521',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '37580',
        '37579'
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_24_7', [
        '501',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '511',
        '541',
        '521',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '2202',
        '937',
        '37524',
        '37548',
        '947',
        '2207',
        '37520',
        '37538',
        '957',
        '959',
        '37528',
        '37543',
        '972',
        '37558',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9620',
        '96200',
        '9621',
        '96210',
        '37580',
        '37579'
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_Priority', [
        '504',
        '514',
        '544',
        '524',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_VIP', [
        '9999',
        '9998',
    ]), true), (0, exports.createFeatureValueMap)('studio_package_picker.robust_infra_group.quota.customer_care.elite', [
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9422',
        '9810',
        '9423',
        '9809',
        '9522',
        '95220',
        '9523',
        '95230',
        '9622',
        '96220',
        '9623',
        '96230',
        '9725',
        '9726',
        '2249',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.main_table.value.enterprise.customer_care', ['2005', '934']), true)),
    excludedInGeos: [types_1.Country.DE],
};
exports.SUPPORT_EU = __assign(__assign({}, exports.SUPPORT), { translationKey: 'Advanced.Features_Values_Support_24_7_EU', value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_24_7_EU', [
        '501',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '511',
        '541',
        '521',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_Priority_EU', [
        '504',
        '514',
        '544',
        '524',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_VIP', [
        '9999',
        '9998',
    ]), true)), excludedInGeos: undefined, includedInGeos: [types_1.Country.DE] });
exports.SUPPORT_FRANCE = {
    translationKey: 'Advanced.Features_Values_Customer_Care_FR_PP',
    tooltipTranslationKey: 'Advanced.Tooltips_Core_Customer_Care_FR_PP',
    includedBySpec: [
        'specs.premium.FranchPackagePicker',
        'specs.premium.JapanesePackagePicker',
    ],
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '501',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '504',
        '514',
        '544',
        '524',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '511',
        '541',
        '521',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_24_7', [
        '501',
        '613',
        '647',
        '723',
        '760',
        '1010',
        '770',
        '7700',
        '7701',
        '900',
        '910',
        '709',
        '702',
        '666',
        '741',
        '792',
        '7920',
        '653',
        '801',
        '8010',
        '732',
        '661',
        '827',
        '812',
        '747',
        '728',
        '779',
        '752',
        '690',
        '697',
        '682',
        '824',
        '675',
        '738',
        '787',
        '531',
        '512',
        '542',
        '522',
        '502',
        '614',
        '648',
        '724',
        '761',
        '771',
        '901',
        '911',
        '917',
        '710',
        '703',
        '667',
        '742',
        '793',
        '654',
        '803',
        '733',
        '532',
        '513',
        '543',
        '523',
        '503',
        '615',
        '649',
        '725',
        '762',
        '772',
        '902',
        '912',
        '711',
        '704',
        '668',
        '743',
        '794',
        '533',
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '511',
        '541',
        '521',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '652',
        '800',
        '8000',
        '731',
        '717',
        '660',
        '6600',
        '826',
        '811',
        '8110',
        '778',
        '7780',
        '746',
        '689',
        '696',
        '681',
        '6810',
        '823',
        '674',
        '737',
        '786',
        '7860',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '673',
        '736',
        '785',
        '7850',
        '718',
        '719',
        '720',
        '721',
        '722',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '777',
        '7770',
        '810',
        '8100',
        '695',
        '688',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_Priority', [
        '504',
        '514',
        '544',
        '524',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '616',
        '763',
        '773',
        '903',
        '913',
        '712',
        '705',
        '669',
        '796',
        '655',
        '805',
        '662',
        '828',
        '813',
        '748',
        '729',
        '769',
        '781',
        '754',
        '691',
        '698',
        '683',
        '832',
        '676',
        '739',
        '788',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Support_VIP', [
        '9999',
        '9998',
    ]), true)),
};
// -------------------------
// Also called: ACCEPT PAYMENTS
exports.SECURE_ONLINE_PAYMENTS = {
    translationKey: 'Advanced.Features_Commerce_Payments',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Payments',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    excludedBySpec: 'specs.premium.Netherlands_Pm_PREM2-11102',
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '933',
        '37581',
        '2004',
        '2005',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '958',
        '37529',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '973',
        '37525',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.SECURE_ONLINE_PAYMENTS_WITH_BENEFIT = __assign(__assign({}, exports.SECURE_ONLINE_PAYMENTS), { excludedBySpec: undefined, includedBySpec: 'specs.premium.Netherlands_Pm_PREM2-11102', benefit: 'premium-purchase-plan.feature_subtitle.secure_payments' });
exports.SECURE_ONLINE_PAYMENTS_EDITOR_X = __assign(__assign({}, exports.SECURE_ONLINE_PAYMENTS), {
    tooltipTranslationKey: 'Editorx.Tooltips_Commerce_Payments',
    includedInProducts: (0, exports.createProductFeatureMap)(['9998']),
});
exports.RECURRING_PAYMENTS_AND_PLANS = {
    translationKey: 'Advanced.Features_Commerce_Paid_Plans',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Paid_Plans',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '617',
        '726',
        '764',
        '774',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    excludedInMobile: true,
};
exports.CUSTOMER_ACCOUNTS = {
    translationKey: 'Advanced.Features_Commerce_Customer_Accounts',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Customer_Accounts',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    excludedInMobile: true,
};
exports.ONLINE_CREDIT_CARD_RATES_US = {
    translationKey: 'Advanced.Features_Commerce_Credit_Card_Rates',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Credit_Card_Rates',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '508',
        '506',
        '509',
        '507',
        '510',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_US_tier_1', [
        '505',
        '508',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_US_tier_2', [
        '506',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_US_tier_3', [
        '507',
        '510',
    ]), true)),
    benefit: 'Advanced.Plans_General_with_Wix_Payments',
    includedInGeos: [types_1.Country.USA],
};
exports.ONLINE_CREDIT_CARD_RATES_GB = {
    translationKey: 'Advanced.Features_Commerce_Credit_Card_Rates',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Credit_Card_Rates',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_GB_tier_1', [
        '515',
        '518',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_GB_tier_2', [
        '516',
        '519',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_GB_tier_3', [
        '517',
        '520',
    ]), true)),
    benefit: 'Advanced.Plans_General_with_Wix_Payments',
    includedInGeos: [types_1.Country.GB],
};
exports.ONLINE_CREDIT_CARD_RATES_EU = {
    translationKey: 'Advanced.Features_Commerce_Credit_Card_Rates',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Credit_Card_Rates',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_EU_tier_1', [
        '515',
        '518',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_EU_tier_2', [
        '516',
        '519',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_EU_tier_3', [
        '517',
        '520',
    ]), true)),
    benefit: 'Advanced.Plans_General_with_Wix_Payments',
    includedInGeos: types_1.CREDIT_CARD_RATES_EU_GEOS,
};
exports.ONLINE_CREDIT_CARD_RATES_CH = {
    translationKey: 'Advanced.Features_Commerce_Credit_Card_Rates',
    tooltipTranslationKey: 'Advanced.Tooltips_Commerce_Credit_Card_Rates',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_CH_tier_1', [
        '515',
        '518',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_CH_tier_2', [
        '516',
        '519',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_CCrate_CH_tier_3', [
        '517',
        '520',
    ]), true)),
    benefit: 'Advanced.Plans_General_with_Wix_Payments',
    includedInGeos: [types_1.Country.CH],
};
exports.CORREIOS_SHIPPING = {
    translationKey: 'Advanced.Features_Stores_Shipping_Correios',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Shipping_Correios',
    includedInProducts: (0, exports.createProductFeatureMap)([
        '684',
        '833',
        '685',
        '834',
        '767',
        '686',
        '835',
        '768',
    ]),
    includedBySpec: 'specs.premium.addCorreiosToOffering_17160',
    benefit: 'Advanced.Features_Stores_Shipping_Correios_line_2',
    includedInGeos: [types_1.Country.BR],
    renewalType: types_1.FeatureRenwalType.RECURRING,
};
exports.LEAD_CAPTURE_FORMS = {
    translationKey: 'premium-purchase-plan.feature_title.forms',
    tooltipTranslationKey: 'premium-purchase-plan.feature_description.forms',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '803',
        '906',
        '916',
        '926',
        '929',
        '905',
        '915',
        '918',
        '925',
        '928',
        '904',
        '914',
        '924',
        '927',
        '903',
        '913',
        '902',
        '912',
        '901',
        '911',
        '917',
        '900',
        '910',
        '672',
        '686',
        '835',
        '572',
        '348',
        '808',
        '490',
        '300',
        '701',
        '273',
        '312',
        '577',
        '715',
        '401',
        '831',
        '438',
        '679',
        '349',
        '799',
        '474',
        '570',
        '356',
        '341',
        '629',
        '364',
        '766',
        '1011',
        '430',
        '735',
        '612',
        '255',
        '694',
        '470',
        '566',
        '816',
        '497',
        '317',
        '756',
        '791',
        '768',
        '445',
        '708',
        '568',
        '665',
        '831',
        '372',
        '478',
        '486',
        '658',
        '776',
        '454',
        '573',
        '639',
        '331',
        '421',
        '283',
        '581',
        '784',
        '646',
        '326',
        '390',
        '751',
        '579',
        '574',
        '381',
        '294',
        '619',
        '730',
        '316',
        '453',
        '403',
        '767',
        '628',
        '473',
        '750',
        '496',
        '565',
        '311',
        '575',
        '734',
        '380',
        '293',
        '671',
        '347',
        '469',
        '657',
        '783',
        '707',
        '437',
        '456',
        '815',
        '830',
        '790',
        '429',
        '325',
        '576',
        '645',
        '444',
        '716',
        '272',
        '775',
        '340',
        '807',
        '638',
        '299',
        '700',
        '254',
        '664',
        '830',
        '402',
        '485',
        '282',
        '580',
        '755',
        '389',
        '651',
        '567',
        '745',
        '618',
        '693',
        '611',
        '740',
        '678',
        '569',
        '489',
        '420',
        '578',
        '400',
        '765',
        '371',
        '714',
        '571',
        '355',
        '798',
        '727',
        '685',
        '834',
        '477',
        '257',
        '315',
        '677',
        '428',
        '561',
        '310',
        '558',
        '726',
        '339',
        '425',
        '298',
        '328',
        '617',
        '610',
        '764',
        '706',
        '797',
        '253',
        '476',
        '806',
        '749',
        '443',
        '814',
        '774',
        '557',
        '292',
        '484',
        '378',
        '563',
        '564',
        '644',
        '782',
        '560',
        '692',
        '452',
        '656',
        '684',
        '833',
        '699',
        '713',
        '562',
        '396',
        '670',
        '369',
        '495',
        '663',
        '829',
        '281',
        '829',
        '419',
        '789',
        '744',
        '650',
        '468',
        '354',
        '346',
        '559',
        '324',
        '637',
        '627',
        '461',
        '387',
        '609',
        '769',
        '636',
        '395',
        '763',
        '691',
        '729',
        '483',
        '399',
        '228',
        '698',
        '643',
        '626',
        '712',
        '185',
        '291',
        '33',
        '391',
        '447',
        '368',
        '475',
        '676',
        '304',
        '280',
        '524',
        '382',
        '435',
        '662',
        '828',
        '252',
        '813',
        '308',
        '410',
        '669',
        '256',
        '705',
        '748',
        '338',
        '353',
        '739',
        '203',
        '418',
        '314',
        '377',
        '442',
        '828',
        '62',
        '788',
        '796',
        '504',
        '345',
        '243',
        '773',
        '427',
        '51',
        '386',
        '168',
        '373',
        '276',
        '451',
        '781',
        '467',
        '616',
        '655',
        '514',
        '297',
        '472',
        '464',
        '683',
        '832',
        '423',
        '265',
        '284',
        '94',
        '238',
        '306',
        '361',
        '805',
        '332',
        '754',
        '305',
        '24',
        '471',
        '394',
        '344',
        '711',
        '285',
        '762',
        '482',
        '772',
        '704',
        '318',
        '434',
        '794',
        '649',
        '668',
        '303',
        '503',
        '466',
        '743',
        '615',
        '286',
        '333',
        '488',
        '307',
        '725',
        '337',
        '296',
        '455',
        '499',
        '812',
        '189',
        '58',
        '500',
        '226',
        '45',
        '68',
        '648',
        '111',
        '336',
        '367',
        '787',
        '161',
        '441',
        '90',
        '433',
        '334',
        '625',
        '690',
        '147',
        '198',
        '295',
        '323',
        '264',
        '724',
        '661',
        '827',
        '269',
        '211',
        '60',
        '309',
        '251',
        '733',
        '771',
        '682',
        '824',
        '654',
        '608',
        '3',
        '703',
        '738',
        '54',
        '513',
        '385',
        '747',
        '761',
        '742',
        '343',
        '426',
        '642',
        '279',
        '28',
        '667',
        '197',
        '31',
        '376',
        '313',
        '728',
        '275',
        '359',
        '502',
        '290',
        '241',
        '149',
        '164',
        '106',
        '329',
        '153',
        '710',
        '413',
        '494',
        '158',
        '481',
        '463',
        '697',
        '393',
        '543',
        '465',
        '824',
        '178',
        '123',
        '523',
        '352',
        '408',
        '405',
        '83',
        '827',
        '73',
        '614',
        '109',
        '192',
        '450',
        '133',
        '126',
        '779',
        '117',
        '92',
        '274',
        '752',
        '49',
        '200',
        '40',
        '172',
        '237',
        '232',
        '635',
        '417',
        '675',
        '793',
        '250',
        '166',
        '39',
        '366',
        '801',
        '8010',
        '811',
        '8110',
        '177',
        '375',
        '741',
        '407',
        '89',
        '412',
        '432',
        '689',
        '666',
        '607',
        '681',
        '6810',
        '823',
        '289',
        '327',
        '501',
        '47',
        '823',
        '613',
        '320',
        '155',
        '258',
        '30',
        '786',
        '7860',
        '136',
        '480',
        '263',
        '512',
        '440',
        '124',
        '702',
        '653',
        '72',
        '641',
        '362',
        '240',
        '110',
        '321',
        '235',
        '826',
        '268',
        '146',
        '737',
        '231',
        '82',
        '448',
        '732',
        '301',
        '132',
        '696',
        '358',
        '44',
        '351',
        '416',
        '225',
        '792',
        '7920',
        '624',
        '746',
        '723',
        '69',
        '674',
        '462',
        '170',
        '57',
        '335',
        '152',
        '27',
        '53',
        '709',
        '330',
        '760',
        '1010',
        '384',
        '175',
        '770',
        '7700',
        '7701',
        '647',
        '778',
        '7780',
        '634',
        '660',
        '6600',
        '826',
        '5',
        '342',
        '424',
        '522',
        '266',
        '322',
        '542',
        '48',
        '278',
        '157',
        '392',
        '116',
        '267',
        '81',
        '731',
        '88',
        '736',
        '145',
        '239',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '56',
        '52',
        '541',
        '606',
        '521',
        '230',
        '156',
        '640',
        '652',
        '411',
        '135',
        '262',
        '439',
        '1',
        '822',
        '406',
        '26',
        '224',
        '374',
        '131',
        '350',
        '620',
        '695',
        '673',
        '38',
        '633',
        '249',
        '357',
        '277',
        '151',
        '449',
        '115',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '800',
        '8000',
        '43',
        '288',
        '32',
        '15',
        '234',
        '165',
        '825',
        '777',
        '7770',
        '431',
        '176',
        '383',
        '810',
        '8100',
        '125',
        '688',
        '415',
        '511',
        '365',
        '174',
        '169',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '37580',
        '37579'
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.forms_4', [
        '900',
        '910',
        '250',
        '166',
        '39',
        '366',
        '801',
        '8010',
        '811',
        '8110',
        '177',
        '375',
        '741',
        '407',
        '89',
        '412',
        '432',
        '689',
        '666',
        '607',
        '681',
        '6810',
        '823',
        '289',
        '327',
        '501',
        '47',
        '823',
        '613',
        '320',
        '155',
        '258',
        '30',
        '786',
        '7860',
        '136',
        '480',
        '263',
        '512',
        '440',
        '124',
        '702',
        '653',
        '72',
        '641',
        '362',
        '240',
        '110',
        '321',
        '235',
        '826',
        '268',
        '146',
        '737',
        '231',
        '82',
        '448',
        '732',
        '301',
        '132',
        '696',
        '358',
        '44',
        '351',
        '416',
        '225',
        '792',
        '7920',
        '624',
        '746',
        '723',
        '69',
        '674',
        '462',
        '170',
        '57',
        '335',
        '152',
        '27',
        '53',
        '709',
        '330',
        '760',
        '1010',
        '384',
        '175',
        '770',
        '7700',
        '7701',
        '647',
        '778',
        '7780',
        '634',
        '660',
        '6600',
        '826',
        '5',
        '342',
        '424',
        '522',
        '266',
        '322',
        '542',
        '48',
        '278',
        '157',
        '392',
        '116',
        '267',
        '81',
        '731',
        '88',
        '736',
        '145',
        '239',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '56',
        '52',
        '541',
        '606',
        '521',
        '230',
        '156',
        '640',
        '652',
        '411',
        '135',
        '262',
        '439',
        '1',
        '822',
        '406',
        '26',
        '224',
        '374',
        '131',
        '350',
        '620',
        '695',
        '673',
        '38',
        '633',
        '249',
        '357',
        '277',
        '151',
        '449',
        '115',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '800',
        '8000',
        '43',
        '288',
        '32',
        '15',
        '234',
        '165',
        '825',
        '777',
        '7770',
        '431',
        '176',
        '383',
        '810',
        '8100',
        '125',
        '688',
        '415',
        '511',
        '365',
        '174',
        '169',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '37579'
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.forms_10', [
        '803',
        '901',
        '911',
        '917',
        '499',
        '812',
        '189',
        '58',
        '500',
        '226',
        '45',
        '68',
        '648',
        '111',
        '336',
        '367',
        '787',
        '161',
        '441',
        '90',
        '433',
        '334',
        '625',
        '690',
        '147',
        '198',
        '295',
        '323',
        '264',
        '724',
        '661',
        '827',
        '269',
        '211',
        '60',
        '309',
        '251',
        '733',
        '771',
        '682',
        '824',
        '654',
        '608',
        '3',
        '703',
        '738',
        '54',
        '513',
        '385',
        '747',
        '761',
        '742',
        '343',
        '426',
        '642',
        '279',
        '28',
        '667',
        '197',
        '31',
        '376',
        '313',
        '728',
        '275',
        '359',
        '502',
        '290',
        '241',
        '149',
        '164',
        '106',
        '329',
        '153',
        '710',
        '413',
        '494',
        '158',
        '481',
        '463',
        '697',
        '393',
        '543',
        '465',
        '824',
        '178',
        '123',
        '523',
        '352',
        '408',
        '405',
        '83',
        '827',
        '73',
        '614',
        '109',
        '192',
        '450',
        '133',
        '126',
        '779',
        '117',
        '92',
        '274',
        '752',
        '49',
        '200',
        '40',
        '172',
        '237',
        '232',
        '635',
        '417',
        '675',
        '793',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '37580'
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.forms_25', [
        '904',
        '914',
        '924',
        '927',
        '902',
        '912',
        '257',
        '315',
        '677',
        '428',
        '561',
        '310',
        '558',
        '726',
        '339',
        '425',
        '298',
        '328',
        '617',
        '610',
        '764',
        '706',
        '797',
        '253',
        '476',
        '806',
        '749',
        '443',
        '814',
        '774',
        '557',
        '292',
        '484',
        '378',
        '563',
        '564',
        '644',
        '782',
        '560',
        '692',
        '452',
        '656',
        '684',
        '833',
        '699',
        '713',
        '562',
        '396',
        '670',
        '369',
        '495',
        '663',
        '829',
        '281',
        '829',
        '419',
        '789',
        '744',
        '650',
        '468',
        '354',
        '346',
        '559',
        '324',
        '637',
        '627',
        '461',
        '387',
        '305',
        '24',
        '471',
        '394',
        '344',
        '711',
        '285',
        '762',
        '482',
        '772',
        '704',
        '318',
        '434',
        '794',
        '649',
        '668',
        '303',
        '503',
        '466',
        '743',
        '615',
        '286',
        '333',
        '488',
        '307',
        '725',
        '337',
        '296',
        '455',
        '932',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '982',
        '37516',
        '2202',
        '937',
        '37524',
        '947',
        '2207',
        '37520',
        '957',
        '959',
        '37528',
        '972',
        '9720',
        '9721',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.forms_75', [
        '905',
        '915',
        '918',
        '925',
        '928',
        '903',
        '913',
        '730',
        '316',
        '453',
        '403',
        '767',
        '628',
        '473',
        '750',
        '496',
        '565',
        '311',
        '575',
        '734',
        '380',
        '293',
        '671',
        '347',
        '469',
        '657',
        '783',
        '707',
        '437',
        '456',
        '815',
        '830',
        '790',
        '429',
        '325',
        '576',
        '645',
        '444',
        '716',
        '272',
        '775',
        '340',
        '807',
        '638',
        '299',
        '700',
        '254',
        '664',
        '830',
        '402',
        '485',
        '282',
        '580',
        '755',
        '389',
        '651',
        '567',
        '745',
        '618',
        '693',
        '611',
        '740',
        '678',
        '569',
        '489',
        '420',
        '578',
        '400',
        '765',
        '371',
        '714',
        '571',
        '355',
        '798',
        '727',
        '685',
        '834',
        '477',
        '609',
        '769',
        '636',
        '395',
        '763',
        '691',
        '729',
        '483',
        '399',
        '228',
        '698',
        '643',
        '626',
        '712',
        '185',
        '291',
        '33',
        '391',
        '447',
        '368',
        '475',
        '676',
        '304',
        '280',
        '524',
        '382',
        '435',
        '662',
        '828',
        '252',
        '813',
        '308',
        '410',
        '669',
        '256',
        '705',
        '748',
        '338',
        '353',
        '739',
        '203',
        '418',
        '314',
        '377',
        '442',
        '828',
        '62',
        '788',
        '796',
        '504',
        '345',
        '243',
        '773',
        '427',
        '51',
        '386',
        '168',
        '373',
        '276',
        '451',
        '781',
        '467',
        '616',
        '655',
        '514',
        '297',
        '472',
        '464',
        '683',
        '832',
        '423',
        '265',
        '284',
        '94',
        '238',
        '306',
        '361',
        '805',
        '332',
        '754',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '9520',
        '95200',
        '9521',
        '95210',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9420',
        '9806',
        '9421',
        '9805',
        '9620',
        '96200',
        '9621',
        '96210',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.forms_150', [
        '906',
        '916',
        '926',
        '929',
        '672',
        '686',
        '835',
        '572',
        '348',
        '808',
        '490',
        '300',
        '701',
        '273',
        '312',
        '577',
        '715',
        '401',
        '831',
        '438',
        '679',
        '349',
        '799',
        '474',
        '570',
        '356',
        '341',
        '629',
        '364',
        '766',
        '1011',
        '430',
        '735',
        '612',
        '255',
        '694',
        '470',
        '566',
        '816',
        '497',
        '317',
        '756',
        '791',
        '768',
        '445',
        '708',
        '568',
        '665',
        '831',
        '372',
        '478',
        '486',
        '658',
        '776',
        '454',
        '573',
        '639',
        '331',
        '421',
        '283',
        '581',
        '784',
        '646',
        '326',
        '390',
        '751',
        '579',
        '574',
        '381',
        '294',
        '619',
        '37538',
        '37533',
        '37543',
        '37548',
        '37553',
        '37558',
    ]), true), (0, exports.createFeatureValueMap)('studio_package_picker.seo_marketing_group.quota.forms.elite', [
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9422',
        '9810',
        '9423',
        '9809',
        '9522',
        '95220',
        '9523',
        '95230',
        '9622',
        '96220',
        '9623',
        '96230',
        '9725',
        '9726',
        '2249',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.main_table.value.enterprise.forms', ['2005', '934']), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.forms_100', [
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]), true)),
    displayProperties: {
        hasNewBadge: true,
    },
};
exports.FIELDS_PER_FORM = {
    translationKey: 'premium-purchase-plan.feature_title.fields',
    tooltipTranslationKey: 'premium-purchase-plan.feature_description.fields',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '803',
        '906',
        '916',
        '926',
        '929',
        '905',
        '915',
        '918',
        '925',
        '928',
        '904',
        '914',
        '924',
        '927',
        '903',
        '913',
        '902',
        '912',
        '901',
        '911',
        '917',
        '900',
        '910',
        '672',
        '686',
        '835',
        '572',
        '348',
        '808',
        '490',
        '300',
        '701',
        '273',
        '312',
        '577',
        '715',
        '401',
        '831',
        '438',
        '679',
        '349',
        '799',
        '474',
        '570',
        '356',
        '341',
        '629',
        '364',
        '766',
        '1011',
        '430',
        '735',
        '612',
        '255',
        '694',
        '470',
        '566',
        '816',
        '497',
        '317',
        '756',
        '791',
        '768',
        '445',
        '708',
        '568',
        '665',
        '831',
        '372',
        '478',
        '486',
        '658',
        '776',
        '454',
        '573',
        '639',
        '331',
        '421',
        '283',
        '581',
        '784',
        '646',
        '326',
        '390',
        '751',
        '579',
        '574',
        '381',
        '294',
        '619',
        '730',
        '316',
        '453',
        '403',
        '767',
        '628',
        '473',
        '750',
        '496',
        '565',
        '311',
        '575',
        '734',
        '380',
        '293',
        '671',
        '347',
        '469',
        '657',
        '783',
        '707',
        '437',
        '456',
        '815',
        '830',
        '790',
        '429',
        '325',
        '576',
        '645',
        '444',
        '716',
        '272',
        '775',
        '340',
        '807',
        '638',
        '299',
        '700',
        '254',
        '664',
        '830',
        '402',
        '485',
        '282',
        '580',
        '755',
        '389',
        '651',
        '567',
        '745',
        '618',
        '693',
        '611',
        '740',
        '678',
        '569',
        '489',
        '420',
        '578',
        '400',
        '765',
        '371',
        '714',
        '571',
        '355',
        '798',
        '727',
        '685',
        '834',
        '477',
        '257',
        '315',
        '677',
        '428',
        '561',
        '310',
        '558',
        '726',
        '339',
        '425',
        '298',
        '328',
        '617',
        '610',
        '764',
        '706',
        '797',
        '253',
        '476',
        '806',
        '749',
        '443',
        '814',
        '774',
        '557',
        '292',
        '484',
        '378',
        '563',
        '564',
        '644',
        '782',
        '560',
        '692',
        '452',
        '656',
        '684',
        '833',
        '699',
        '713',
        '562',
        '396',
        '670',
        '369',
        '495',
        '663',
        '829',
        '281',
        '829',
        '419',
        '789',
        '744',
        '650',
        '468',
        '354',
        '346',
        '559',
        '324',
        '637',
        '627',
        '461',
        '387',
        '609',
        '769',
        '636',
        '395',
        '763',
        '691',
        '729',
        '483',
        '399',
        '228',
        '698',
        '643',
        '626',
        '712',
        '185',
        '291',
        '33',
        '391',
        '447',
        '368',
        '475',
        '676',
        '304',
        '280',
        '524',
        '382',
        '435',
        '662',
        '828',
        '252',
        '813',
        '308',
        '410',
        '669',
        '256',
        '705',
        '748',
        '338',
        '353',
        '739',
        '203',
        '418',
        '314',
        '377',
        '442',
        '828',
        '62',
        '788',
        '796',
        '504',
        '345',
        '243',
        '773',
        '427',
        '51',
        '386',
        '168',
        '373',
        '276',
        '451',
        '781',
        '467',
        '616',
        '655',
        '514',
        '297',
        '472',
        '464',
        '683',
        '832',
        '423',
        '265',
        '284',
        '94',
        '238',
        '306',
        '361',
        '805',
        '332',
        '754',
        '305',
        '24',
        '471',
        '394',
        '344',
        '711',
        '285',
        '762',
        '482',
        '772',
        '704',
        '318',
        '434',
        '794',
        '649',
        '668',
        '303',
        '503',
        '466',
        '743',
        '615',
        '286',
        '333',
        '488',
        '307',
        '725',
        '337',
        '296',
        '455',
        '499',
        '812',
        '189',
        '58',
        '500',
        '226',
        '45',
        '68',
        '648',
        '111',
        '336',
        '367',
        '787',
        '161',
        '441',
        '90',
        '433',
        '334',
        '625',
        '690',
        '147',
        '198',
        '295',
        '323',
        '264',
        '724',
        '661',
        '827',
        '269',
        '211',
        '60',
        '309',
        '251',
        '733',
        '771',
        '682',
        '824',
        '654',
        '608',
        '3',
        '703',
        '738',
        '54',
        '513',
        '385',
        '747',
        '761',
        '742',
        '343',
        '426',
        '642',
        '279',
        '28',
        '667',
        '197',
        '31',
        '376',
        '313',
        '728',
        '275',
        '359',
        '502',
        '290',
        '241',
        '149',
        '164',
        '106',
        '329',
        '153',
        '710',
        '413',
        '494',
        '158',
        '481',
        '463',
        '697',
        '393',
        '543',
        '465',
        '824',
        '178',
        '123',
        '523',
        '352',
        '408',
        '405',
        '83',
        '827',
        '73',
        '614',
        '109',
        '192',
        '450',
        '133',
        '126',
        '779',
        '117',
        '92',
        '274',
        '752',
        '49',
        '200',
        '40',
        '172',
        '237',
        '232',
        '635',
        '417',
        '675',
        '793',
        '250',
        '166',
        '39',
        '366',
        '801',
        '8010',
        '811',
        '8110',
        '177',
        '375',
        '741',
        '407',
        '89',
        '412',
        '432',
        '689',
        '666',
        '607',
        '681',
        '6810',
        '823',
        '289',
        '327',
        '501',
        '47',
        '823',
        '613',
        '320',
        '155',
        '258',
        '30',
        '786',
        '7860',
        '136',
        '480',
        '263',
        '512',
        '440',
        '124',
        '702',
        '653',
        '72',
        '641',
        '362',
        '240',
        '110',
        '321',
        '235',
        '826',
        '268',
        '146',
        '737',
        '231',
        '82',
        '448',
        '732',
        '301',
        '132',
        '696',
        '358',
        '44',
        '351',
        '416',
        '225',
        '792',
        '7920',
        '624',
        '746',
        '723',
        '69',
        '674',
        '462',
        '170',
        '57',
        '335',
        '152',
        '27',
        '53',
        '709',
        '330',
        '760',
        '1010',
        '384',
        '175',
        '770',
        '7700',
        '7701',
        '647',
        '778',
        '7780',
        '634',
        '660',
        '6600',
        '826',
        '5',
        '342',
        '424',
        '522',
        '266',
        '322',
        '542',
        '48',
        '278',
        '157',
        '392',
        '116',
        '267',
        '81',
        '731',
        '88',
        '736',
        '145',
        '239',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '56',
        '52',
        '541',
        '606',
        '521',
        '230',
        '156',
        '640',
        '652',
        '411',
        '135',
        '262',
        '439',
        '1',
        '822',
        '406',
        '26',
        '224',
        '374',
        '131',
        '350',
        '620',
        '695',
        '673',
        '38',
        '633',
        '249',
        '357',
        '277',
        '151',
        '449',
        '115',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '800',
        '8000',
        '43',
        '288',
        '32',
        '15',
        '234',
        '165',
        '825',
        '777',
        '7770',
        '431',
        '176',
        '383',
        '810',
        '8100',
        '125',
        '688',
        '415',
        '511',
        '365',
        '174',
        '169',
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37526',
        '375340',
        '37580',
        '37579'
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.fields_10', [
        '930',
        '9301',
        '2218',
        '9302',
        '2221',
        '9303',
        '2220',
        '9304',
        '2219',
        '9305',
        '2225',
        '2001',
        '2011',
        '2006',
        '2016',
        '2273',
        '1212',
        '20160',
        '2100',
        '2113',
        '2110',
        '2101',
        '2121',
        '2111',
        '2102',
        '2122',
        '2112',
        '2103',
        '2123',
        '37522',
        '37545',
        '2104',
        '2124',
        '37518',
        '37535',
        '2204',
        '2105',
        '2115',
        '2109',
        '2119',
        '2106',
        '37555',
        '2116',
        '2108',
        '2118',
        '37550',
        '2107',
        '2117',
        '940',
        '9401',
        '9802',
        '9402',
        '9803',
        '9403',
        '9804',
        '950',
        '9501',
        '95010',
        '9502',
        '95020',
        '9503',
        '95030',
        '980',
        '9801',
        '2200',
        '22001',
        '37514',
        '37530',
        '22002',
        '935',
        '945',
        '955',
        '970',
        '9701',
        '2222',
        '9702',
        '2224',
        '9703',
        '2223',
        '9704',
        '2226',
        '974',
        '960',
        '9601',
        '96010',
        '9602',
        '96020',
        '9603',
        '96030',
        '900',
        '910',
        '250',
        '166',
        '39',
        '366',
        '801',
        '8010',
        '811',
        '8110',
        '177',
        '375',
        '741',
        '407',
        '89',
        '412',
        '432',
        '689',
        '666',
        '607',
        '681',
        '6810',
        '823',
        '289',
        '327',
        '501',
        '47',
        '823',
        '613',
        '320',
        '155',
        '258',
        '30',
        '786',
        '7860',
        '136',
        '480',
        '263',
        '512',
        '440',
        '124',
        '702',
        '653',
        '72',
        '641',
        '362',
        '240',
        '110',
        '321',
        '235',
        '826',
        '268',
        '146',
        '737',
        '231',
        '82',
        '448',
        '732',
        '301',
        '132',
        '696',
        '358',
        '44',
        '351',
        '416',
        '225',
        '792',
        '7920',
        '624',
        '746',
        '723',
        '69',
        '674',
        '462',
        '170',
        '57',
        '335',
        '152',
        '27',
        '53',
        '709',
        '330',
        '760',
        '1010',
        '384',
        '175',
        '770',
        '7700',
        '7701',
        '647',
        '778',
        '7780',
        '634',
        '660',
        '6600',
        '826',
        '5',
        '342',
        '424',
        '522',
        '266',
        '322',
        '542',
        '48',
        '278',
        '157',
        '392',
        '116',
        '267',
        '81',
        '731',
        '88',
        '736',
        '145',
        '239',
        '680',
        '6802',
        '6801',
        '6800',
        '822',
        '56',
        '52',
        '541',
        '606',
        '521',
        '230',
        '156',
        '640',
        '652',
        '411',
        '135',
        '262',
        '439',
        '1',
        '822',
        '406',
        '26',
        '224',
        '374',
        '131',
        '350',
        '620',
        '695',
        '673',
        '38',
        '633',
        '249',
        '357',
        '277',
        '151',
        '449',
        '115',
        '659',
        '6591',
        '6592',
        '6590',
        '825',
        '800',
        '8000',
        '43',
        '288',
        '32',
        '15',
        '234',
        '165',
        '825',
        '777',
        '7770',
        '431',
        '176',
        '383',
        '810',
        '8100',
        '125',
        '688',
        '415',
        '511',
        '365',
        '174',
        '169',
        '37579'
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.fields_20', [
        '803',
        '901',
        '911',
        '917',
        '499',
        '812',
        '189',
        '58',
        '500',
        '226',
        '45',
        '68',
        '648',
        '111',
        '336',
        '367',
        '787',
        '161',
        '441',
        '90',
        '433',
        '334',
        '625',
        '690',
        '147',
        '198',
        '295',
        '323',
        '264',
        '724',
        '661',
        '827',
        '269',
        '211',
        '60',
        '309',
        '251',
        '733',
        '771',
        '682',
        '824',
        '654',
        '608',
        '3',
        '703',
        '738',
        '54',
        '513',
        '385',
        '747',
        '761',
        '742',
        '343',
        '426',
        '642',
        '279',
        '28',
        '667',
        '197',
        '31',
        '376',
        '313',
        '728',
        '275',
        '359',
        '502',
        '290',
        '241',
        '149',
        '164',
        '106',
        '329',
        '153',
        '710',
        '413',
        '494',
        '158',
        '481',
        '463',
        '697',
        '393',
        '543',
        '465',
        '824',
        '178',
        '123',
        '523',
        '352',
        '408',
        '405',
        '83',
        '827',
        '73',
        '614',
        '109',
        '192',
        '450',
        '133',
        '126',
        '779',
        '117',
        '92',
        '274',
        '752',
        '49',
        '200',
        '40',
        '172',
        '237',
        '232',
        '635',
        '417',
        '675',
        '793',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.fields_50', [
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '904',
        '914',
        '924',
        '927',
        '902',
        '912',
        '257',
        '315',
        '677',
        '428',
        '561',
        '310',
        '558',
        '726',
        '339',
        '425',
        '298',
        '328',
        '617',
        '610',
        '764',
        '706',
        '797',
        '253',
        '476',
        '806',
        '749',
        '443',
        '814',
        '774',
        '557',
        '292',
        '484',
        '378',
        '563',
        '564',
        '644',
        '782',
        '560',
        '692',
        '452',
        '656',
        '684',
        '833',
        '699',
        '713',
        '562',
        '396',
        '670',
        '369',
        '495',
        '663',
        '829',
        '281',
        '829',
        '419',
        '789',
        '744',
        '650',
        '468',
        '354',
        '346',
        '559',
        '324',
        '637',
        '627',
        '461',
        '387',
        '305',
        '24',
        '471',
        '394',
        '344',
        '711',
        '285',
        '762',
        '482',
        '772',
        '704',
        '318',
        '434',
        '794',
        '649',
        '668',
        '303',
        '503',
        '466',
        '743',
        '615',
        '286',
        '333',
        '488',
        '307',
        '725',
        '337',
        '296',
        '455',
        '37580'
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.fields_75', [
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37534',
        '2202',
        '937',
        '37524',
        '37549',
        '947',
        '2207',
        '37520',
        '37539',
        '957',
        '959',
        '37528',
        '37544',
        '972',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '905',
        '915',
        '918',
        '925',
        '928',
        '903',
        '913',
        '730',
        '316',
        '453',
        '403',
        '767',
        '628',
        '473',
        '750',
        '496',
        '565',
        '311',
        '575',
        '734',
        '380',
        '293',
        '671',
        '347',
        '469',
        '657',
        '783',
        '707',
        '437',
        '456',
        '815',
        '830',
        '790',
        '429',
        '325',
        '576',
        '645',
        '444',
        '716',
        '272',
        '775',
        '340',
        '807',
        '638',
        '299',
        '700',
        '254',
        '664',
        '830',
        '402',
        '485',
        '282',
        '580',
        '755',
        '389',
        '651',
        '567',
        '745',
        '618',
        '693',
        '611',
        '740',
        '678',
        '569',
        '489',
        '420',
        '578',
        '400',
        '765',
        '371',
        '714',
        '571',
        '355',
        '798',
        '727',
        '685',
        '834',
        '477',
        '609',
        '769',
        '636',
        '395',
        '763',
        '691',
        '729',
        '483',
        '399',
        '228',
        '698',
        '643',
        '626',
        '712',
        '185',
        '291',
        '33',
        '391',
        '447',
        '368',
        '475',
        '676',
        '304',
        '280',
        '524',
        '382',
        '435',
        '662',
        '828',
        '252',
        '813',
        '308',
        '410',
        '669',
        '256',
        '705',
        '748',
        '338',
        '353',
        '739',
        '203',
        '418',
        '314',
        '377',
        '442',
        '828',
        '62',
        '788',
        '796',
        '504',
        '345',
        '243',
        '773',
        '427',
        '51',
        '386',
        '168',
        '373',
        '276',
        '451',
        '781',
        '467',
        '616',
        '655',
        '514',
        '297',
        '472',
        '464',
        '683',
        '832',
        '423',
        '265',
        '284',
        '94',
        '238',
        '306',
        '361',
        '805',
        '332',
        '754',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.fields_100', [
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '906',
        '916',
        '926',
        '929',
        '672',
        '686',
        '835',
        '572',
        '348',
        '808',
        '490',
        '300',
        '701',
        '273',
        '312',
        '577',
        '715',
        '401',
        '831',
        '438',
        '679',
        '349',
        '799',
        '474',
        '570',
        '356',
        '341',
        '629',
        '364',
        '766',
        '1011',
        '430',
        '735',
        '612',
        '255',
        '694',
        '470',
        '566',
        '816',
        '497',
        '317',
        '756',
        '791',
        '768',
        '445',
        '708',
        '568',
        '665',
        '831',
        '372',
        '478',
        '486',
        '658',
        '776',
        '454',
        '573',
        '639',
        '331',
        '421',
        '283',
        '581',
        '784',
        '646',
        '326',
        '390',
        '751',
        '579',
        '574',
        '381',
        '294',
        '619',
        '37538',
        '37533',
        '37543',
        '37548',
        '37553',
        '37558',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.main_table.value.enterprise.fields', ['2005', '934']), true)),
    displayProperties: {
        hasNewBadge: true,
    },
};
exports.advancedPlansCommonFeatures = [
    exports.SECURE_ONLINE_PAYMENTS,
    exports.SECURE_ONLINE_PAYMENTS_EDITOR_X,
    exports.RECURRING_PAYMENTS_AND_PLANS,
    exports.CUSTOMER_ACCOUNTS,
    exports.ONLINE_CREDIT_CARD_RATES_US,
    exports.ONLINE_CREDIT_CARD_RATES_GB,
    exports.ONLINE_CREDIT_CARD_RATES_EU,
    exports.ONLINE_CREDIT_CARD_RATES_CH,
    exports.CONNECT_A_CUSTOM_DOMAIN,
    exports.FREE_DOMAIN_FOR_1_YEAR,
    exports.REMOVE_WIX_ADS,
    exports.REMOVE_EDITOR_X_BRANDING,
    exports.SUPPORT_FRANCE,
    exports.FREE_SSL_CERTIFICATE,
    exports.CONTRIBUTORS,
    exports.BANDWIDTH,
    exports.STORAGE,
    exports.STORAGE_EDITOR_X,
    exports.LEAD_CAPTURE_FORMS,
    exports.FIELDS_PER_FORM,
    exports.NEW_US_AD_VOUCHER_300,
    exports.NEW_CA_AD_VOUCHER_300,
    exports.AD_VOUCHER_75,
    exports.AD_VOUCHER_75_GB,
    exports.YANDEX_VOUCHER,
    exports.LEGAL_TEXT_WEBSITE,
    exports.SITE_BOOSTER,
    exports.VISITOR_ANALYTICS,
    exports.EVENTS_CALENDAR,
    exports.ADVANCED_REPORT_BUILDER,
    exports.SUPPORT,
    exports.SUPPORT_EU,
];
exports.advancedPlansBusinessCommonFeatures = [
    exports.SECURE_ONLINE_PAYMENTS,
    exports.SECURE_ONLINE_PAYMENTS_EDITOR_X,
    exports.RECURRING_PAYMENTS_AND_PLANS,
    exports.CUSTOMER_ACCOUNTS,
    exports.ONLINE_CREDIT_CARD_RATES_US,
    exports.ONLINE_CREDIT_CARD_RATES_GB,
    exports.ONLINE_CREDIT_CARD_RATES_EU,
    exports.ONLINE_CREDIT_CARD_RATES_CH,
    exports.CONNECT_A_CUSTOM_DOMAIN,
    exports.FREE_DOMAIN_FOR_1_YEAR,
    exports.REMOVE_WIX_ADS,
    exports.REMOVE_EDITOR_X_BRANDING,
    exports.SUPPORT_FRANCE,
    exports.FREE_SSL_CERTIFICATE,
    exports.CONTRIBUTORS,
    exports.BANDWIDTH,
    exports.STORAGE,
    exports.STORAGE_EDITOR_X,
    exports.LEAD_CAPTURE_FORMS,
    exports.FIELDS_PER_FORM,
    exports.NEW_US_AD_VOUCHER_300,
    exports.NEW_CA_AD_VOUCHER_300,
    exports.AD_VOUCHER_75,
    exports.AD_VOUCHER_75_GB,
    exports.YANDEX_VOUCHER,
    exports.SITE_BOOSTER,
    exports.VISITOR_ANALYTICS,
    exports.EVENTS_CALENDAR,
    exports.LEGAL_TEXT_BUSINESS,
    exports.ADVANCED_REPORT_BUILDER,
    exports.SUPPORT,
    exports.SUPPORT_EU,
];
// ---------- Complete eCommerce Solution ----------
exports.UNLIMITED_PRODUCTS = {
    translationKey: 'Advanced.Features_Stores_Unlimited_Products',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Unlimited_Products',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '999',
    ]),
};
exports.PRODUCT_CATALOG_FEATURE = {
    translationKey: 'premium_purchase_plan.eComm_platform_group.feature_title.product_catalog',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Unlimited_Products',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], products_1.SUNRISE_PLANS.Core, true), products_1.SUNRISE_PLANS.Business, true), products_1.SUNRISE_PLANS.Elite, true), products_1.SUNRISE_PLANS.Enterprise, true)),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.product_catalog.core', __spreadArray([], products_1.SUNRISE_PLANS.Core, true)), true), (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.product_catalog.business', __spreadArray([], products_1.SUNRISE_PLANS.Business, true)), true), (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.product_catalog.elite', __spreadArray([], products_1.SUNRISE_PLANS.Elite, true)), true), (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.product_catalog.enterprise', __spreadArray([], products_1.SUNRISE_PLANS.Enterprise, true)), true)),
};
exports.ABANDOND_CART_RECOVERY = {
    translationKey: 'Advanced.Features_Stores_Cart_Recovery',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Cart_Recovery',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.SUBSCRIPTIONS = {
    translationKey: 'Advanced.Features_Stores_Subscriptions',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Subscriptions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '999',
    ]),
    excludedInGeos: [types_1.Country.IN],
};
exports.TINY_ERP = {
    translationKey: 'Advanced.Features_Stores_Invoice_and_marketplaces',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Invoice_and_marketplaces',
    renewalType: types_1.FeatureRenwalType.ONE_TIME,
    includedInProducts: (0, exports.createProductFeatureMap)(['767', '768']),
    benefit: 'Advanced.Features_Stores_Invoice_and_marketplaces_line_2',
    includedInGeos: [types_1.Country.BR],
    disabledInMonthlyCycle: true,
};
exports.MULTIPLE_CURRENCIES = {
    translationKey: 'Advanced.Features_Stores_Multicurrency',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Multicurrency',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
    ]),
};
exports.AUTOMATED_SALE_TAX = {
    translationKey: 'Advanced.Features_Stores_Automated_Sales_Tax',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Automated_Sales_Tax',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '9901',
        '9902',
        '9903',
        '9904',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Automated_Sales_Tax_100_transactions', [
        '932',
        '9321',
        '2227',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '2003',
        '942',
        '9424',
        '952',
        '9524',
        '982',
        '37516',
        '37533',
        '2202',
        '937',
        '37524',
        '37548',
        '947',
        '2207',
        '37520',
        '37538',
        '957',
        '959',
        '37528',
        '37543',
        '972',
        '37558',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Automated_Sales_Tax_500_transactions', [
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9320',
        '2232',
        '9520',
        '95200',
        '9722',
        '2235',
        '9420',
        '9806',
        '9620',
        '96200',
        '9322',
        '2228',
        '9323',
        '2229',
        '9521',
        '95210',
        '9723',
        '2233',
        '9421',
        '9805',
        '9621',
        '96210',
        '9324',
        '2230',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true), (0, exports.createFeatureValueMap)('studio_package_picker.ecomm_platform_group.quota.automated_sales_tax.elite', [
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9422',
        '9810',
        '9423',
        '9809',
        '9522',
        '95220',
        '9523',
        '95230',
        '9622',
        '96220',
        '9623',
        '96230',
        '9725',
        '9726',
        '2249',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.main_table.value.enterprise.automated_sales_tax', ['2005', '934', '37539', '37534', '37544', '37549', '37554', '37559']), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Automated_Sales_Tax.unlimited', [
        '9901',
        '9902',
        '9903',
        '9904',
        '9905',
        '9906',
        '9907',
        '9908',
        '9909',
        '9910',
        '9911',
        '9912',
        '9913',
        '9914',
        '9925',
        '9926',
        '9927',
        '9928',
        '9929',
    ]), true)),
    excludedInGeos: types_1.AVALARA_EXCLUDED_GEOS,
};
exports.SHIPPING_LABLES = {
    translationKey: 'Advanced.Features_Stores_Shipping_Labels',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Shipping_Labels',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
    ]),
    includedInGeos: [
        types_1.Country.USA,
        types_1.Country.CA,
        types_1.Country.AU,
        types_1.Country.FR,
        types_1.Country.DE,
        types_1.Country.GB,
    ],
};
exports.SELL_ON_SOCIAL_MEDIA = {
    translationKey: 'Advanced.Features_Stores_Social',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Social',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    excludedInMobile: true,
    excludedBySpec: 'specs.premium.RemovePPFeaturesforStoresCatalogV3'
};
exports.SELL_ON_MARKETPLACES = {
    translationKey: 'Advanced.Features_Stores_Marketplaces',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Marketplaces',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    excludedInGeos: [types_1.Country.IN, types_1.Country.BR],
    excludedBySpec: 'specs.premium.RemovePPFeaturesforStoresCatalogV3',
};
exports.TRUSTED_SHOPS = {
    translationKey: 'Advanced.Features_Stores_Trusted_Shops_product_reviews',
    tooltipTranslationKey: 'Advanced_Tooltips_Stores_Trusted_Shops_product_reviews',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedBySpec: 'specs.premium.TrustedShops_PREM2_2237',
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
    ]),
    disabledInMonthlyCycle: true,
};
exports.DROPSHIPPING_MODALYST = {
    translationKey: 'Advanced.Features_Stores_Dropshipping',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Dropshipping',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
    ]),
    value: new Map(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Dropshipping_250', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Dropshipping_unlimited', [
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]), true)),
    disabledInMonthlyCycle: true,
};
exports.DROPSHIPPING_MODALYST_SUNRISE = {
    translationKey: 'premium_purchase_plan.eComm_platform_group.feature_title.dropshipping_modalyst',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Dropshipping',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], products_1.SUNRISE_PLANS.Core, true), products_1.SUNRISE_PLANS.Business, true), products_1.SUNRISE_PLANS.Elite, true), products_1.SUNRISE_PLANS.Enterprise, true)),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.dropshipping_modalyst.core', __spreadArray([], products_1.SUNRISE_PLANS.Core, true)), true), (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.dropshipping_modalyst.business', __spreadArray([], (0, array_utils_1.reduceArrayFromArray)(products_1.SUNRISE_PLANS.Business, [
        '37538',
        '37533',
        '37543',
        '37548',
        '37553',
        '37558',
    ]), true)), true), (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.dropshipping_modalyst.elite', __spreadArray([], products_1.SUNRISE_PLANS.Elite, true)), true), (0, exports.createFeatureValueMap)('premium_purchase_plan.eComm_platform_group.quota.dropshipping_modalyst.enterprise', __spreadArray([], products_1.SUNRISE_PLANS.Enterprise, true)), true)),
    disabledInMonthlyCycle: true,
};
exports.PRODUCT_REVIEWS_KUDOBUZZ = {
    translationKey: 'Advanced.Features_Stores_Reviews',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Reviews',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    excludedInGeos: [types_1.Country.DE],
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Reviews_1000', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '2202',
        '937',
        '37524',
        '37548',
        '947',
        '2207',
        '37520',
        '37538',
        '957',
        '959',
        '37528',
        '37543',
        '972',
        '37558',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Reviews_3000', [
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.main_table.value.enterprise.product_reviews', ['2005', '934']), true)),
    disabledInMonthlyCycle: true,
    excludedBySpec: 'specs.premium.Product_Reviews_PP_Display_PREM2-14443',
};
exports.PRODUCTS_REVIEWS = {
    translationKey: 'premium_purchase_plan.eComm_platform_group.feature_title.product_reviews',
    tooltipTranslationKey: 'premium_purchase_plan.eComm_platform_group.feature_description.product_reviews',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '9999',
        '9998',
        '999',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    includedBySpec: 'specs.premium.Product_Reviews_PP_Display_PREM2-14443',
};
exports.LOYALTY_PROGRAM_SMILE_IO = {
    translationKey: 'Advanced.Features_Stores_Loyalty_Program',
    tooltipTranslationKey: 'Advanced.Tooltips_Stores_Loyalty_Program',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '510',
        '517',
        '520',
        '527',
        '530',
        '537',
        '540',
        '547',
        '550',
        '9999',
        '9998',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
    ]),
    excludedInGeos: [types_1.Country.JA, types_1.Country.FR, types_1.Country.BR, types_1.Country.RU],
    excludedBySpec: 'specs.premium.Loyalty_Referal_PREM2-9891',
    disabledInMonthlyCycle: true,
};
exports.EMAIL_CAMPAIGHNS = {
    translationKey: 'Advanced.Features_Marketing_Email_Campaigns',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Email_Campaigns',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
        '37537',
        '37532',
        '37542',
        '37547',
        '37552',
        '37557',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_5_per_month', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_20_per_month', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '37537',
        '37532',
        '37542',
        '37547',
        '37552',
        '37557',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_unlimited_per_month', [
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]), true)),
};
exports.TOTAL_EMAILS = {
    translationKey: 'Advanced.Features_Marketing_Total_Emails',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Total_Emails',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '37537',
        '37532',
        '37542',
        '37547',
        '37552',
        '37557',
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_9500_per_month', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '37537',
        '37532',
        '37542',
        '37547',
        '37552',
        '37557',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_50000_per_month', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_million_per_month', [
        '37539',
        '37534',
        '37544',
        '37549',
        '37554',
        '37559',
    ]), true)),
};
exports.AUTOMATIONS = {
    translationKey: 'Advanced.Features_Marketing_Automations',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Automations',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_7', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_20', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true)),
};
exports.CUSTOMIZABLE_FORMS = {
    translationKey: 'Advanced.Features_Marketing_Customizable_Forms',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Customizable_Forms',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_10', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_Up_to_20', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999']), true)),
};
exports.MULTISTEP_FORMS = {
    translationKey: 'Advanced.Features_Marketing_Multistep_Forms',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Multistep_Forms',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
};
exports.PAYMENT_FORMS = {
    translationKey: 'Advanced.Features_Marketing_Payment_Forms',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Payment_Forms',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
};
exports.ADVANCED_CHAT_FEATURES = {
    translationKey: 'Advanced.Features_Marketing_Advanced_Chat_Features',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Advanced_Chat_Features',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
};
exports.SCHEDULED_CHAT_HOURS = {
    translationKey: 'Advanced.Features_Marketing_Scheduled_Chat_Hours',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Scheduled_Chat_Hours',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
};
exports.SHARE_SOCIAL_POSTS = {
    translationKey: 'Advanced.Features_Marketing_Share_Social_Posts',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Share_Social_Posts',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_5_per_month', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_20_per_month', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true)),
};
exports.SCHEDULE_SOCIAL_POSTS = {
    translationKey: 'Advanced.Features_Marketing_Scheduled_Social_Posts',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Scheduled_Social_Posts',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '507',
        '537',
        '540',
        '509',
        '510',
        '9999',
        '9998',
        '516',
        '546',
        '549',
        '526',
        '529',
        '517',
        '547',
        '550',
        '527',
        '530',
        '519',
        '520',
    ]),
};
exports.PROFESSIONAL_VIDEO_ADS = {
    translationKey: 'Advanced.Features_Marketing_Professional_Video_Ads',
    tooltipTranslationKey: 'Advanced.Tooltips_Marketing_Professional_Video_Ads',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_5_per_month', [
        '506',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Features_Values_10_per_month', [
        '507',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true)),
};
// export const MARKETING_SUITE: AdvancedPlansFeatureSection = {
//   translationKey: 'Advanced.Plans_Verticals_Ascend_title',
//   descriptionTranslationKey: 'Advanced.Plans_Verticals_Ascend_subheader',
//   features: [
//     EMAIL_CAMPAIGHNS,
//     TOTAL_EMAILS,
//     AUTOMATIONS,
//     CUSTOMIZABLE_FORMS,
//     MULTISTEP_FORMS,
//     PAYMENT_FORMS,
//     ADVANCED_CHAT_FEATURES,
//     SCHEDULED_CHAT_HOURS,
//     SHARE_SOCIAL_POSTS,
//     SCHEDULE_SOCIAL_POSTS,
//     PROFESSIONAL_VIDEO_ADS,
//   ],
//   isAscend: true,
//   intent: [],
//   icon: AscendIcon,
//   displayInMobile: true,
//   category: SectionCategory.MARKETING_SUITE,
// };
// ------------Bookings---------------------
exports.UNLIMITED_SERVICES_CLASSES = {
    translationKey: 'Advanced.Features_Bookings_Unlimited_Services',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_Unlimited_Services',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.MULTI_CALENDAR_SYNC = {
    translationKey: 'Advanced.Features_Bookings_Multicalendar_sync',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_Multicalendar_sync',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.STAFF_SEATS = {
    translationKey: 'Advanced.Features_Bookings_Staff_Seats',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_Staff_Seats',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
    ]),
};
exports.STAFF_SEATS_SUNRISE_STUDIO = {
    translationKey: 'Advanced.Features_Bookings_Staff_Seats',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_Staff_Seats',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], products_1.SUNRISE_PLANS.Core, true), products_1.SUNRISE_PLANS.Business, true), products_1.SUNRISE_PLANS.Elite, true), products_1.SUNRISE_PLANS.Enterprise, true)),
    excludedBySpec: 'specs.bookings.StaffMembersPremiumLimits',
};
exports.SUBSCRIPTIONS_MEMBERSHIPS = {
    translationKey: 'Advanced.Features_Bookings_Subscriptions',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_Subscriptions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.SMS_NOTIFICATIONS_QUOTA_FEATURE = {
    translationKey: 'Advanced.Features_Bookings_SMS',
    tooltipTranslationKey: 'Advanced.Tooltips_Bookings_SMS',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '37517',
        '37521',
        '37569',
        '938',
        '37570',
        '943',
        '948',
        '963',
        '933',
        '37581',
        '37529',
        '958',
        '37571',
        '983',
        '2203',
        '977',
        '2004',
        '973',
        '37525',
        '2208',
        '953',
        '9423',
        '2003',
        '959',
        '9522',
        '37534',
        '37528',
        '2228',
        '9760',
        '957',
        '96200',
        '9327',
        '37544',
        '9722',
        '9909',
        '942',
        '9523',
        '2202',
        '95230',
        '37553',
        '2009',
        '2010',
        '2099',
        '937',
        '9906',
        '2232',
        '37539',
        '9421',
        '37538',
        '9521',
        '9720',
        '2207',
        '9914',
        '37549',
        '2233',
        '96220',
        '972',
        '932',
        '982',
        '2229',
        '9620',
        '9926',
        '95200',
        '37516',
        '9322',
        '9422',
        '37524',
        '96230',
        '9321',
        '95220',
        '2008',
        '37554',
        '9761',
        '2235',
        '9810',
        '9805',
        '9520',
        '37520',
        '2246',
        '9323',
        '9726',
        '9809',
        '9908',
        '2234',
        '9621',
        '25',
        '9928',
        '9911',
        '37558',
        '95210',
        '9624',
        '2019',
        '947',
        '9326',
        '9424',
        '9913',
        '2249',
        '2247',
        '37566',
        '2227',
        '9320',
        '962',
        '37559',
        '2248',
        '9524',
        '9907',
        '37543',
        '37567',
        '96210',
        '9910',
        '37548',
        '9927',
        '37568',
        '9912',
        '9328',
        '37533',
        '976',
        '9725',
        '952',
        '9420',
        '9623',
        '9721',
        '9724',
        '9806',
        '2215',
        '9713',
        '9410',
        '37546',
        '9412',
        '37557',
        '95100',
        '9903',
        '37560',
        '9317',
        '2002',
        '9750',
        '37551',
        '936',
        '37541',
        '9901',
        '9513',
        '95120',
        '37519',
        '2238',
        '37532',
        '941',
        '2007',
        '2077',
        '961',
        '2214',
        '9904',
        '2209',
        '9919',
        '9714',
        '37561',
        '37537',
        '9515',
        '37527',
        '9808',
        '9918',
        '37542',
        '22011',
        '9921',
        '2216',
        '2213',
        '9510',
        '95130',
        '971',
        '9923',
        '956',
        '9610',
        '9712',
        '975',
        '9310',
        '9920',
        '9514',
        '9316',
        '2241',
        '9613',
        '37531',
        '9315',
        '931',
        '37515',
        '9411',
        '37562',
        '9807',
        '96100',
        '9312',
        '946',
        '2017',
        '2201',
        '9922',
        '37523',
        '37552',
        '9710',
        '9917',
        '9915',
        '96120',
        '22012',
        '37536',
        '9711',
        '9902',
        '9314',
        '96130',
        '9924',
        '96140',
        '9614',
        '2217',
        '37564',
        '9800',
        '9900',
        '9311',
        '2237',
        '37556',
        '981',
        '9413',
        '2210',
        '9916',
        '2206',
        '9615',
        '2240',
        '9715',
        '951',
        '9512',
        '2211',
        '95140',
        '2212',
        '37565',
        '9313',
        '37580'
    ]),
    value: new Map(__spreadArray(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.Bookings_SMS_250', [
        '37517',
        '37521',
        '37569',
        '938',
        '37570',
        '943',
        '948',
        '963',
        '933',
        '37581',
        '37529',
        '958',
        '37571',
        '983',
        '2203',
        '977',
        '2004',
        '973',
        '37525',
        '2208',
        '953',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.Bookings_SMS_100', [
        '9423',
        '2003',
        '959',
        '9522',
        '37534',
        '37528',
        '2228',
        '9760',
        '957',
        '96200',
        '9327',
        '37544',
        '9722',
        '9909',
        '942',
        '9523',
        '2202',
        '95230',
        '37553',
        '2009',
        '2010',
        '2099',
        '937',
        '9906',
        '2232',
        '37539',
        '9421',
        '37538',
        '9521',
        '9720',
        '2207',
        '9914',
        '37549',
        '2233',
        '96220',
        '972',
        '932',
        '982',
        '2229',
        '9620',
        '9926',
        '95200',
        '37516',
        '9322',
        '9422',
        '37524',
        '96230',
        '9321',
        '95220',
        '2008',
        '37554',
        '9761',
        '2235',
        '9810',
        '9805',
        '9520',
        '37520',
        '2246',
        '9323',
        '9726',
        '9809',
        '9908',
        '2234',
        '9621',
        '25',
        '9928',
        '9911',
        '37558',
        '95210',
        '9624',
        '2019',
        '947',
        '9326',
        '9424',
        '9913',
        '2249',
        '2247',
        '37566',
        '2227',
        '9320',
        '962',
        '37559',
        '2248',
        '9524',
        '9907',
        '37543',
        '37567',
        '96210',
        '9910',
        '37548',
        '9927',
        '37568',
        '9912',
        '9328',
        '37533',
        '976',
        '9725',
        '952',
        '9420',
        '9623',
        '9721',
        '9724',
        '9806',
    ]), true), (0, exports.createFeatureValueMap)('premium-purchase-plan.feature_value.Bookings_SMS_50', [
        '2215',
        '9713',
        '9410',
        '37546',
        '9412',
        '37557',
        '95100',
        '9903',
        '37560',
        '9317',
        '2002',
        '9750',
        '37551',
        '936',
        '37541',
        '9901',
        '9513',
        '95120',
        '37519',
        '2238',
        '37532',
        '941',
        '2007',
        '2077',
        '961',
        '2214',
        '9904',
        '2209',
        '9919',
        '9714',
        '37561',
        '37537',
        '9515',
        '37527',
        '9808',
        '9918',
        '37542',
        '22011',
        '9921',
        '2216',
        '2213',
        '9510',
        '95130',
        '971',
        '9923',
        '956',
        '9610',
        '9712',
        '975',
        '9310',
        '9920',
        '9514',
        '9316',
        '2241',
        '9613',
        '37531',
        '9315',
        '931',
        '37515',
        '9411',
        '37562',
        '9807',
        '96100',
        '9312',
        '946',
        '2017',
        '2201',
        '9922',
        '37523',
        '37552',
        '9710',
        '9917',
        '9915',
        '96120',
        '22012',
        '37536',
        '9711',
        '9902',
        '9314',
        '96130',
        '9924',
        '96140',
        '9614',
        '2217',
        '37564',
        '9800',
        '9900',
        '9311',
        '2237',
        '37556',
        '981',
        '9413',
        '2210',
        '9916',
        '2206',
        '9615',
        '2240',
        '9715',
        '951',
        '9512',
        '2211',
        '95140',
        '2212',
        '37565',
        '9313',
        '37580'
    ]), true)),
};
var commonBookingsOnTheGoData = {
    translationKey: 'Advanced.Features_Verticals_Bookings_on_the_go',
    tooltipTranslationKey: 'Advanced.Tooltips_Verticals_Bookings_on_the_go',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.BOOKING_ON_THE_GO = commonBookingsOnTheGoData;
exports.BOOKING_ON_THE_GO_EDITOR_X = __assign(__assign({}, commonBookingsOnTheGoData), {
    tooltipTranslationKey: 'Editorx.Tooltips_Verticals_Bookings_on_the_go',
    includedInProducts: (0, exports.createProductFeatureMap)(['9998']),
});
exports.BOOKINGS_ANALYTICS = {
    translationKey: 'Advanced.Features_Verticals_Bookings_Analytics',
    tooltipTranslationKey: 'Advanced.Tooltips_Verticals_Bookings_Analytics',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
// ----------Events-----------------------
exports.UNLIMITED_TECKETS_AND_EVENTS = {
    translationKey: 'Advanced.Features_Events_Unlimited_Events',
    tooltipTranslationKey: 'Advanced.Tooltips_Events_Unlimited_Events',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.TICKET_SALE_COMMISION = {
    translationKey: 'Advanced.Features_Events_Ticket_Sales_Commission',
    tooltipTranslationKey: 'Advanced.Tooltips_Events_Ticket_Sales_Commission',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
    value: new Map(__spreadArray(__spreadArray([], (0, exports.createFeatureValueMap)('Advanced.Features_Values_2.5_percent_commission', [
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]), true), (0, exports.createFeatureValueMap)('Advanced.Plans_General_Custom', ['9999', '9998']), true)),
};
exports.PASS_TICKET_FEES = {
    translationKey: 'Advanced.Features_Events_Pass_Ticket_Fees',
    tooltipTranslationKey: 'Advanced.Tooltips_Events_Pass_Ticket_Fees',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
var commonMobileTicketsFeatureData = {
    translationKey: 'Advanced.Features_Events_Mobile_Tickets',
    tooltipTranslationKey: 'Advanced.Tooltips_Events_Mobile_Tickets',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.MOBILE_TICKETS = commonMobileTicketsFeatureData;
exports.MOBILE_TICKETS_EDITOR_X = __assign(__assign({}, commonMobileTicketsFeatureData), {
    tooltipTranslationKey: 'Editorx.Tooltips_Events_Mobile_Tickets',
    includedInProducts: (0, exports.createProductFeatureMap)(['9998']),
});
// ---------------Music, Video< Art Store------------------
exports.STREAM_SELL_MUSIC = {
    translationKey: 'Advanced.Features_Music&Video_Stream',
    tooltipTranslationKey: 'Advanced.Tooltips_Music&Video_Stream',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
exports.SELL_ART_WORK = {
    translationKey: 'Advanced.Features_Music&Video_Sell_Artwork',
    tooltipTranslationKey: 'Advanced.Tooltips_Music&Video_Sell_Artwork',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '505',
        '617',
        '726',
        '764',
        '774',
        '904',
        '914',
        '924',
        '927',
        '820',
        '821',
        '713',
        '706',
        '650',
        '670',
        '744',
        '797',
        '656',
        '806',
        '663',
        '829',
        '814',
        '782',
        '749',
        '692',
        '699',
        '684',
        '833',
        '677',
        '789',
        '535',
        '538',
        '515',
        '545',
        '548',
        '525',
        '528',
        '518',
        '508',
        '506',
        '618',
        '727',
        '765',
        '775',
        '905',
        '915',
        '918',
        '925',
        '928',
        '716',
        '714',
        '707',
        '651',
        '671',
        '745',
        '798',
        '657',
        '807',
        '734',
        '664',
        '830',
        '815',
        '750',
        '730',
        '783',
        '755',
        '693',
        '700',
        '685',
        '834',
        '767',
        '678',
        '740',
        '790',
        '536',
        '539',
        '516',
        '546',
        '549',
        '526',
        '529',
        '519',
        '509',
        '507',
        '619',
        '766',
        '1011',
        '776',
        '906',
        '916',
        '926',
        '929',
        '715',
        '708',
        '672',
        '799',
        '658',
        '808',
        '735',
        '665',
        '831',
        '816',
        '784',
        '756',
        '751',
        '694',
        '701',
        '686',
        '835',
        '768',
        '679',
        '791',
        '537',
        '540',
        '517',
        '547',
        '550',
        '527',
        '530',
        '520',
        '510',
        '9999',
        '9998',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '2002',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '936',
        '37523',
        '37546',
        '37547',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '956',
        '37527',
        '37541',
        '37542',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '975',
        '9750',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '2003',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '937',
        '37524',
        '37548',
        '37549',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '957',
        '959',
        '37528',
        '37543',
        '37544',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '976',
        '9760',
        '9761',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '933',
        '37581',
        '2004',
        '943',
        '953',
        '983',
        '37517',
        '2203',
        '938',
        '939',
        '948',
        '2208',
        '37521',
        '958',
        '37529',
        '973',
        '37525',
        '977',
        '963',
        '2005',
        '934',
        '37580'
    ]),
};
// -------------Restaurants--------------------
exports.ONLINE_ORDERS = {
    translationKey: 'Advanced.Features_Restaurants_Online_Orders',
    tooltipTranslationKey: 'Advanced.Tooltips_Restaurants_Online_Orders',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '505',
        '506',
        '507',
        '508',
        '509',
        '510',
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
        '525',
        '526',
        '527',
        '528',
        '529',
        '530',
        '535',
        '536',
        '537',
        '538',
        '539',
        '540',
        '545',
        '546',
        '547',
        '548',
        '549',
        '550',
        '617',
        '618',
        '619',
        '650',
        '651',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '706',
        '707',
        '708',
        '713',
        '714',
        '715',
        '716',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '9998',
        '9999',
        '37580'
    ]),
};
exports.RESERVATIONS_MANAGEMENT = {
    translationKey: 'Advanced.Features_Restaurants_Reservations',
    tooltipTranslationKey: 'Advanced.Tooltips_Restaurants_Reservations',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '505',
        '506',
        '507',
        '508',
        '509',
        '510',
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
        '525',
        '526',
        '527',
        '528',
        '529',
        '530',
        '535',
        '536',
        '537',
        '538',
        '539',
        '540',
        '545',
        '546',
        '547',
        '548',
        '549',
        '550',
        '617',
        '618',
        '619',
        '650',
        '651',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '706',
        '707',
        '708',
        '713',
        '714',
        '715',
        '716',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '9998',
        '9999',
        '37580'
    ]),
};
exports.CUSTOME_MENUS = {
    translationKey: 'Advanced.Features_Restaurants_Menu',
    tooltipTranslationKey: 'Advanced.Tooltips_Restaurants_Menu',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '505',
        '506',
        '507',
        '508',
        '509',
        '509',
        '510',
        '515',
        '516',
        '517',
        '518',
        '519',
        '520',
        '525',
        '526',
        '527',
        '528',
        '529',
        '530',
        '535',
        '536',
        '537',
        '538',
        '539',
        '540',
        '545',
        '546',
        '547',
        '548',
        '549',
        '550',
        '617',
        '618',
        '619',
        '650',
        '651',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '706',
        '707',
        '708',
        '713',
        '714',
        '715',
        '716',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '9998',
        '9999',
        '37580'
    ]),
};
// -------------Fitness--------------------
exports.AUTOMATED_REMINDERS = {
    translationKey: 'Advanced_Features_Fitness_Automated_Reminders',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Automated_Reminders',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.CUSTOMIZED_ANALYTICS = {
    translationKey: 'Advanced_Features_Fitness_Custom_Analytics',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Custom_Analytics',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2004',
        '2005',
        '619',
        '658',
        '665',
        '672',
        '679',
        '686',
        '694',
        '701',
        '715',
        '735',
        '751',
        '756',
        '766',
        '768',
        '776',
        '784',
        '791',
        '799',
        '808',
        '816',
        '831',
        '835',
        '906',
        '916',
        '926',
        '929',
        '933',
        '37581',
        '934',
        '938',
        '939',
        '943',
        '948',
        '2208',
        '37521',
        '953',
        '958',
        '37529',
        '963',
        '973',
        '37525',
        '977',
        '983',
        '37517',
        '2203',
    ]),
};
exports.SCHEDULING_SERVICES = {
    translationKey: 'Advanced_Features_Fitness_Scheduling_Services',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Scheduling_Services',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.DEDICATED_MEMBERS_APP = {
    translationKey: 'Advanced_Features_Fitness_Members_App',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Members_App',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.MEMBERSHIPS_PACKAGES = {
    translationKey: 'Advanced_Features_Fitness_Memberships_and_Packages',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Memberships_and_Packages',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.MULTIPLE_LOCATIONS = {
    translationKey: 'Advanced_Features_Fitness_Multiple_Locations',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Multiple_Locations',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
    ]),
};
exports.ONLINE_SESSIONS = {
    translationKey: 'Advanced_Features_Fitness_Online_Sessions',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Online_Sessions',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.ONLINE_STORE = {
    translationKey: 'Advanced_Features_Fitness_Online_Store',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Online_Store',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.STAFF_MANAGEMENT = {
    translationKey: 'Advanced_Features_Fitness_Staff_Management',
    tooltipTranslationKey: 'Advanced_Tooltips_Fitness_Staff_Management',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)([
        '1011',
        '2002',
        '2003',
        '2004',
        '2005',
        '617',
        '618',
        '619',
        '656',
        '657',
        '658',
        '663',
        '664',
        '665',
        '670',
        '671',
        '672',
        '677',
        '678',
        '679',
        '684',
        '685',
        '686',
        '692',
        '693',
        '694',
        '699',
        '700',
        '701',
        '713',
        '714',
        '715',
        '726',
        '727',
        '730',
        '734',
        '735',
        '740',
        '744',
        '745',
        '749',
        '750',
        '751',
        '755',
        '756',
        '764',
        '765',
        '766',
        '767',
        '768',
        '774',
        '775',
        '776',
        '782',
        '783',
        '784',
        '789',
        '790',
        '791',
        '797',
        '798',
        '799',
        '806',
        '807',
        '808',
        '814',
        '815',
        '816',
        '820',
        '821',
        '829',
        '830',
        '831',
        '833',
        '834',
        '835',
        '904',
        '905',
        '906',
        '914',
        '915',
        '916',
        '918',
        '924',
        '925',
        '926',
        '927',
        '928',
        '929',
        '931',
        '9316',
        '2237',
        '9317',
        '2238',
        '2007',
        '2077',
        '2017',
        '9921',
        '9916',
        '9901',
        '9310',
        '2244',
        '2239',
        '2214',
        '9311',
        '2209',
        '9312',
        '2210',
        '9313',
        '2243',
        '2236',
        '2211',
        '9314',
        '2212',
        '9315',
        '2213',
        '932',
        '9326',
        '2247',
        '9327',
        '2248',
        '9328',
        '2246',
        '9320',
        '2232',
        '9321',
        '2227',
        '9322',
        '2228',
        '9323',
        '2229',
        '9324',
        '2230',
        '9325',
        '2231',
        '2008',
        '2009',
        '2010',
        '2099',
        '2019',
        '9926',
        '9911',
        '9906',
        '933',
        '37581',
        '934',
        '936',
        '37523',
        '37546',
        '37547',
        '937',
        '37524',
        '37548',
        '37549',
        '938',
        '939',
        '941',
        '9413',
        '9920',
        '9915',
        '9904',
        '9900',
        '9411',
        '9807',
        '9412',
        '9808',
        '9410',
        '9800',
        '942',
        '9424',
        '9925',
        '9910',
        '9905',
        '9422',
        '9810',
        '9423',
        '9809',
        '9420',
        '9806',
        '9421',
        '9805',
        '943',
        '946',
        '2206',
        '37519',
        '37536',
        '37537',
        '947',
        '2207',
        '37520',
        '37538',
        '37539',
        '948',
        '2208',
        '37521',
        '951',
        '9515',
        '9924',
        '9919',
        '9513',
        '95130',
        '9514',
        '95140',
        '9510',
        '95100',
        '9511',
        '95110',
        '9512',
        '95120',
        '952',
        '9524',
        '9929',
        '9914',
        '9909',
        '9522',
        '95220',
        '9523',
        '95230',
        '9520',
        '95200',
        '9521',
        '95210',
        '953',
        '956',
        '37527',
        '37541',
        '37542',
        '957',
        '958',
        '37529',
        '959',
        '37528',
        '37543',
        '37544',
        '961',
        '9615',
        '9923',
        '9918',
        '9903',
        '9613',
        '96130',
        '9614',
        '96140',
        '9610',
        '96100',
        '9611',
        '96110',
        '9612',
        '96120',
        '962',
        '9624',
        '9928',
        '9913',
        '9908',
        '9622',
        '96220',
        '9623',
        '96230',
        '9620',
        '96200',
        '9621',
        '96210',
        '963',
        '971',
        '37556',
        '37557',
        '9714',
        '2240',
        '9715',
        '2241',
        '9713',
        '37551',
        '37552',
        '9922',
        '9917',
        '9902',
        '9710',
        '2245',
        '2242',
        '2217',
        '9711',
        '2215',
        '9712',
        '2216',
        '972',
        '37558',
        '37559',
        '9725',
        '9726',
        '2249',
        '9722',
        '2235',
        '9723',
        '2233',
        '9724',
        '2234',
        '9720',
        '9721',
        '37553',
        '37554',
        '9927',
        '9912',
        '9907',
        '973',
        '37525',
        '975',
        '9750',
        '976',
        '9760',
        '9761',
        '977',
        '981',
        '2201',
        '22011',
        '37515',
        '37531',
        '37532',
        '22012',
        '982',
        '37516',
        '37533',
        '37534',
        '2202',
        '983',
        '37517',
        '2203',
        '37580'
    ]),
};
exports.MULTIPLE_STAFF_MANAGEMENT = {
    translationKey: 'premium_purchase_plan.bookings_platform_group.staff_mgmt.feature_title',
    tooltipTranslationKey: 'premium_purchase_plan.bookings_platform_group.staff_mgmt.feature_description',
    renewalType: types_1.FeatureRenwalType.RECURRING,
    includedInProducts: (0, exports.createProductFeatureMap)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], products_1.SUNRISE_PLANS.Business, true), products_1.SUNRISE_PLANS.Elite, true), products_1.SUNRISE_PLANS.Enterprise, true), products_1.STUDIO_PLUS_PLANS, true), products_1.STUDIO_ELITE_PLANS, true), products_1.STUDIO_ENTERPRISE_PLANS, true)),
    includedBySpec: 'specs.bookings.StaffMembersPremiumLimits',
};
exports.ADVANCED_PLANS_FEATURES = [
    exports.TEST_PRODUCT,
    exports.STAFFY,
    exports.BANDWIDTH,
    exports.REMOVE_WIX_ADS,
    exports.REMOVE_EDITOR_X_BRANDING,
    exports.CONNECT_A_CUSTOM_DOMAIN,
    exports.FREE_DOMAIN_FOR_1_YEAR,
    exports.FREE_SSL_CERTIFICATE,
    exports.STORAGE,
    exports.STORAGE_EDITOR_X,
    exports.CONTRIBUTORS,
    exports.NEW_US_AD_VOUCHER_300,
    exports.NEW_CA_AD_VOUCHER_300,
    exports.AD_VOUCHER_75,
    exports.AD_VOUCHER_75_GB,
    exports.YANDEX_VOUCHER,
    exports.SITE_BOOSTER,
    exports.LEGAL_TEXT_WEBSITE,
    exports.VISITOR_ANALYTICS,
    exports.EVENTS_CALENDAR,
    exports.LEGAL_TEXT_BUSINESS,
    exports.ADVANCED_REPORT_BUILDER,
    exports.SUPPORT,
    exports.SUPPORT_EU,
    exports.SUPPORT_FRANCE,
    exports.SECURE_ONLINE_PAYMENTS,
    exports.SECURE_ONLINE_PAYMENTS_EDITOR_X,
    exports.RECURRING_PAYMENTS_AND_PLANS,
    exports.CUSTOMER_ACCOUNTS,
    exports.ONLINE_CREDIT_CARD_RATES_US,
    exports.ONLINE_CREDIT_CARD_RATES_GB,
    exports.ONLINE_CREDIT_CARD_RATES_EU,
    exports.ONLINE_CREDIT_CARD_RATES_CH,
    exports.CORREIOS_SHIPPING,
    exports.LEAD_CAPTURE_FORMS,
    exports.FIELDS_PER_FORM,
    exports.UNLIMITED_PRODUCTS,
    exports.PRODUCT_CATALOG_FEATURE,
    exports.ABANDOND_CART_RECOVERY,
    exports.SUBSCRIPTIONS,
    exports.TINY_ERP,
    exports.MULTIPLE_CURRENCIES,
    exports.AUTOMATED_SALE_TAX,
    exports.SHIPPING_LABLES,
    exports.SELL_ON_SOCIAL_MEDIA,
    exports.SELL_ON_MARKETPLACES,
    exports.TRUSTED_SHOPS,
    exports.DROPSHIPPING_MODALYST,
    exports.DROPSHIPPING_MODALYST_SUNRISE,
    exports.PRODUCT_REVIEWS_KUDOBUZZ,
    exports.LOYALTY_PROGRAM_SMILE_IO,
    exports.EMAIL_CAMPAIGHNS,
    exports.TOTAL_EMAILS,
    exports.AUTOMATIONS,
    exports.CUSTOMIZABLE_FORMS,
    exports.MULTISTEP_FORMS,
    exports.PAYMENT_FORMS,
    exports.ADVANCED_CHAT_FEATURES,
    exports.SCHEDULED_CHAT_HOURS,
    exports.SHARE_SOCIAL_POSTS,
    exports.SCHEDULE_SOCIAL_POSTS,
    exports.PROFESSIONAL_VIDEO_ADS,
    exports.UNLIMITED_SERVICES_CLASSES,
    exports.MULTI_CALENDAR_SYNC,
    exports.STAFF_SEATS,
    exports.SUBSCRIPTIONS_MEMBERSHIPS,
    exports.SMS_NOTIFICATIONS_QUOTA_FEATURE,
    exports.BOOKING_ON_THE_GO,
    exports.BOOKING_ON_THE_GO_EDITOR_X,
    exports.BOOKINGS_ANALYTICS,
    exports.UNLIMITED_TECKETS_AND_EVENTS,
    exports.TICKET_SALE_COMMISION,
    exports.PASS_TICKET_FEES,
    exports.MOBILE_TICKETS,
    exports.MOBILE_TICKETS_EDITOR_X,
    exports.STREAM_SELL_MUSIC,
    exports.SELL_ART_WORK,
    exports.ONLINE_ORDERS,
    exports.RESERVATIONS_MANAGEMENT,
    exports.CUSTOME_MENUS,
    exports.AUTOMATED_REMINDERS,
    exports.CUSTOMIZED_ANALYTICS,
    exports.SCHEDULING_SERVICES,
    exports.DEDICATED_MEMBERS_APP,
    exports.MEMBERSHIPS_PACKAGES,
    exports.MULTIPLE_LOCATIONS,
    exports.ONLINE_SESSIONS,
    exports.ONLINE_STORE,
    exports.STAFF_MANAGEMENT,
    exports.MULTIPLE_STAFF_MANAGEMENT,
    exports.STAFF_SEATS_SUNRISE_STUDIO,
];
//# sourceMappingURL=features.js.map